import React, { useState, useRef, useEffect } from 'react';
import './ThemeSelector.css';
import CloseIcon from '@mui/icons-material/Close';

const themes = [
  {
    id: 'modern-dark',
    name: 'Modern Koyu',
    colors: {
      buttonGradient1: '#1A1A1A',
      buttonGradient2: '#333333',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#3B82F6',
      buttonGlowColor: '#3B82F6',
      headerBg: 'rgba(26, 26, 26, 0.7)',
      headerIconColor: '#3B82F6',
      backgroundGradient1: '#0F172A',
      backgroundGradient2: '#1E293B',
      backgroundColor1: '#333333',
      backgroundColor2: '#1A1A1A',
      textColor1: '#FFFFFF',
      textColor2: '#CCCCCC',
      borderColor: '#3B82F6',
      pointerColor: '#3B82F6',
      radiusLineColor: '#333333'
    }
  },
  {
    id: 'neon-purple',
    name: 'Neon Mor',
    colors: {
      buttonGradient1: '#2D1B69',
      buttonGradient2: '#4B2CA2',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#9D4EDD',
      buttonGlowColor: '#9D4EDD',
      headerBg: 'rgba(45, 27, 105, 0.7)',
      headerIconColor: '#9D4EDD',
      backgroundGradient1: '#13073A',
      backgroundGradient2: '#2D1B69',
      backgroundColor1: '#4B2CA2',
      backgroundColor2: '#2D1B69',
      textColor1: '#FFFFFF',
      textColor2: '#E0AAFF',
      borderColor: '#9D4EDD',
      pointerColor: '#9D4EDD',
      radiusLineColor: '#4B2CA2'
    }
  },
  {
    id: 'ocean-breeze',
    name: 'Okyanus Esintisi',
    colors: {
      buttonGradient1: '#0B4F6C',
      buttonGradient2: '#1B7BA8',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#20A4F3',
      buttonGlowColor: '#20A4F3',
      headerBg: 'rgba(11, 79, 108, 0.7)',
      headerIconColor: '#20A4F3',
      backgroundGradient1: '#01222F',
      backgroundGradient2: '#073B4C',
      backgroundColor1: '#1B7BA8',
      backgroundColor2: '#0B4F6C',
      textColor1: '#FFFFFF',
      textColor2: '#B8E3FF',
      borderColor: '#20A4F3',
      pointerColor: '#20A4F3',
      radiusLineColor: '#1B7BA8'
    }
  },
  {
    id: 'sunset-vibes',
    name: 'Gün Batımı',
    colors: {
      buttonGradient1: '#FF6B6B',
      buttonGradient2: '#FF8E8E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD93D',
      buttonGlowColor: '#FFD93D',
      headerBg: 'rgba(255, 107, 107, 0.7)',
      headerIconColor: '#FFD93D',
      backgroundGradient1: '#4A1D1F',
      backgroundGradient2: '#8C3D3D',
      backgroundColor1: '#FF6B6B',
      backgroundColor2: '#FF8E8E',
      textColor1: '#FFFFFF',
      textColor2: '#FFE8E8',
      borderColor: '#FFD93D',
      pointerColor: '#FFD93D',
      radiusLineColor: '#FF8E8E'
    }
  },
  {
    id: 'cyber-mint',
    name: 'Siber Nane',
    colors: {
      buttonGradient1: '#2D3436',
      buttonGradient2: '#434C4E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00FF9D',
      buttonGlowColor: '#00FF9D',
      headerBg: 'rgba(45, 52, 54, 0.7)',
      headerIconColor: '#00FF9D',
      backgroundGradient1: '#1A1E1F',
      backgroundGradient2: '#2D3436',
      backgroundColor1: '#434C4E',
      backgroundColor2: '#2D3436',
      textColor1: '#FFFFFF',
      textColor2: '#B2FFD6',
      borderColor: '#00FF9D',
      pointerColor: '#00FF9D',
      radiusLineColor: '#434C4E'
    }
  },
  {
    id: 'royal-gold',
    name: 'Kraliyet Altını',
    colors: {
      buttonGradient1: '#2C1810',
      buttonGradient2: '#4A2B1B',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(44, 24, 16, 0.7)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#1A0F0A',
      backgroundGradient2: '#2C1810',
      backgroundColor1: '#4A2B1B',
      backgroundColor2: '#2C1810',
      textColor1: '#FFFFFF',
      textColor2: '#FFE5B4',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#4A2B1B'
    }
  },
  {
    id: 'electric-blue',
    name: 'Elektrik Mavisi',
    colors: {
      buttonGradient1: '#0A1929',
      buttonGradient2: '#0F2942',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00C6FF',
      buttonGlowColor: '#00C6FF',
      headerBg: 'rgba(10, 25, 41, 0.7)',
      headerIconColor: '#00C6FF',
      backgroundGradient1: '#050E17',
      backgroundGradient2: '#0A1929',
      backgroundColor1: '#0F2942',
      backgroundColor2: '#0A1929',
      textColor1: '#FFFFFF',
      textColor2: '#B3ECFF',
      borderColor: '#00C6FF',
      pointerColor: '#00C6FF',
      radiusLineColor: '#0F2942'
    }
  },
  {
    id: 'cherry-blossom',
    name: 'Kiraz Çiçeği',
    colors: {
      buttonGradient1: '#FF758F',
      buttonGradient2: '#FF8FA3',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFB7C5',
      buttonGlowColor: '#FFB7C5',
      headerBg: 'rgba(255, 117, 143, 0.7)',
      headerIconColor: '#FFB7C5',
      backgroundGradient1: '#2D1A1E',
      backgroundGradient2: '#4A2932',
      backgroundColor1: '#FF758F',
      backgroundColor2: '#FF8FA3',
      textColor1: '#FFFFFF',
      textColor2: '#FFE4E9',
      borderColor: '#FFB7C5',
      pointerColor: '#FFB7C5',
      radiusLineColor: '#FF8FA3'
    }
  },
  {
    id: 'emerald-city',
    name: 'Zümrüt Şehri',
    colors: {
      buttonGradient1: '#004D40',
      buttonGradient2: '#00695C',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00BFA5',
      buttonGlowColor: '#00BFA5',
      headerBg: 'rgba(0, 77, 64, 0.7)',
      headerIconColor: '#00BFA5',
      backgroundGradient1: '#002B23',
      backgroundGradient2: '#004D40',
      backgroundColor1: '#00695C',
      backgroundColor2: '#004D40',
      textColor1: '#FFFFFF',
      textColor2: '#B2DFDB',
      borderColor: '#00BFA5',
      pointerColor: '#00BFA5',
      radiusLineColor: '#00695C'
    }
  },
  {
    id: 'arctic-aurora',
    name: 'Kutup Işıkları',
    colors: {
      buttonGradient1: '#0F3443',
      buttonGradient2: '#1F5F6B',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#34E89E',
      buttonGlowColor: '#34E89E',
      headerBg: 'rgba(15, 52, 67, 0.7)',
      headerIconColor: '#34E89E',
      backgroundGradient1: '#0A1F28',
      backgroundGradient2: '#0F3443',
      backgroundColor1: '#1F5F6B',
      backgroundColor2: '#0F3443',
      textColor1: '#FFFFFF',
      textColor2: '#B4FFE4',
      borderColor: '#34E89E',
      pointerColor: '#34E89E',
      radiusLineColor: '#1F5F6B'
    }
  },
  {
    id: 'cosmic-dust',
    name: 'Kozmik Toz',
    colors: {
      buttonGradient1: '#2E1437',
      buttonGradient2: '#4B1E54',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF61D2',
      buttonGlowColor: '#FF61D2',
      headerBg: 'rgba(46, 20, 55, 0.7)',
      headerIconColor: '#FF61D2',
      backgroundGradient1: '#1A0B20',
      backgroundGradient2: '#2E1437',
      backgroundColor1: '#4B1E54',
      backgroundColor2: '#2E1437',
      textColor1: '#FFFFFF',
      textColor2: '#FFB8E6',
      borderColor: '#FF61D2',
      pointerColor: '#FF61D2',
      radiusLineColor: '#4B1E54'
    }
  },
  {
    id: 'desert-oasis',
    name: 'Çöl Vahası',
    colors: {
      buttonGradient1: '#C4742F',
      buttonGradient2: '#D68D4C',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#8FC088',
      buttonGlowColor: '#8FC088',
      headerBg: 'rgba(196, 116, 47, 0.7)',
      headerIconColor: '#8FC088',
      backgroundGradient1: '#8B4513',
      backgroundGradient2: '#C4742F',
      backgroundColor1: '#D68D4C',
      backgroundColor2: '#C4742F',
      textColor1: '#FFFFFF',
      textColor2: '#E8FFE4',
      borderColor: '#8FC088',
      pointerColor: '#8FC088',
      radiusLineColor: '#D68D4C'
    }
  },
  {
    id: 'neon-tokyo',
    name: 'Neon Tokyo',
    colors: {
      buttonGradient1: '#1A1A2E',
      buttonGradient2: '#16213E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF2E63',
      buttonGlowColor: '#FF2E63',
      headerBg: 'rgba(26, 26, 46, 0.7)',
      headerIconColor: '#FF2E63',
      backgroundGradient1: '#0F0F1A',
      backgroundGradient2: '#1A1A2E',
      backgroundColor1: '#16213E',
      backgroundColor2: '#1A1A2E',
      textColor1: '#FFFFFF',
      textColor2: '#FFB8C6',
      borderColor: '#FF2E63',
      pointerColor: '#FF2E63',
      radiusLineColor: '#16213E'
    }
  },
  {
    id: 'forest-mist',
    name: 'Orman Sisi',
    colors: {
      buttonGradient1: '#2D5A27',
      buttonGradient2: '#3E7B37',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#98FB98',
      buttonGlowColor: '#98FB98',
      headerBg: 'rgba(45, 90, 39, 0.7)',
      headerIconColor: '#98FB98',
      backgroundGradient1: '#1B3409',
      backgroundGradient2: '#2D5A27',
      backgroundColor1: '#3E7B37',
      backgroundColor2: '#2D5A27',
      textColor1: '#FFFFFF',
      textColor2: '#D4FFD4',
      borderColor: '#98FB98',
      pointerColor: '#98FB98',
      radiusLineColor: '#3E7B37'
    }
  },
  {
    id: 'deep-ocean',
    name: 'Derin Okyanus',
    colors: {
      buttonGradient1: '#1B262C',
      buttonGradient2: '#0F4C75',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#3282B8',
      buttonGlowColor: '#3282B8',
      headerBg: 'rgba(27, 38, 44, 0.7)',
      headerIconColor: '#3282B8',
      backgroundGradient1: '#0A1014',
      backgroundGradient2: '#1B262C',
      backgroundColor1: '#0F4C75',
      backgroundColor2: '#1B262C',
      textColor1: '#FFFFFF',
      textColor2: '#BBE1FA',
      borderColor: '#3282B8',
      pointerColor: '#3282B8',
      radiusLineColor: '#0F4C75'
    }
  },
  {
    id: 'volcanic-night',
    name: 'Volkanik Gece',
    colors: {
      buttonGradient1: '#3D0000',
      buttonGradient2: '#950101',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF0000',
      buttonGlowColor: '#FF0000',
      headerBg: 'rgba(61, 0, 0, 0.7)',
      headerIconColor: '#FF0000',
      backgroundGradient1: '#1A0000',
      backgroundGradient2: '#3D0000',
      backgroundColor1: '#950101',
      backgroundColor2: '#3D0000',
      textColor1: '#FFFFFF',
      textColor2: '#FFB8B8',
      borderColor: '#FF0000',
      pointerColor: '#FF0000',
      radiusLineColor: '#950101'
    }
  },
  {
    id: 'cotton-candy',
    name: 'Pamuk Şeker',
    colors: {
      buttonGradient1: '#FFB8D1',
      buttonGradient2: '#FFC8E6',
      buttonTextColor: '#4A1259',
      buttonBorderColor: '#B8B8FF',
      buttonGlowColor: '#B8B8FF',
      headerBg: 'rgba(255, 184, 209, 0.7)',
      headerIconColor: '#B8B8FF',
      backgroundGradient1: '#FFDFEF',
      backgroundGradient2: '#FFB8D1',
      backgroundColor1: '#FFC8E6',
      backgroundColor2: '#FFB8D1',
      textColor1: '#4A1259',
      textColor2: '#6B1B83',
      borderColor: '#B8B8FF',
      pointerColor: '#B8B8FF',
      radiusLineColor: '#FFC8E6'
    }
  },
  {
    id: 'cyberpunk-yellow',
    name: 'Siberpunk Sarı',
    colors: {
      buttonGradient1: '#242424',
      buttonGradient2: '#333333',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(36, 36, 36, 0.7)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#0D0D0D',
      backgroundGradient2: '#242424',
      backgroundColor1: '#333333',
      backgroundColor2: '#242424',
      textColor1: '#FFFFFF',
      textColor2: '#FFE77A',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#333333'
    }
  },
  {
    id: 'matrix-code',
    name: 'Matrix Kodu',
    colors: {
      buttonGradient1: '#0D0208',
      buttonGradient2: '#003B00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00FF41',
      buttonGlowColor: '#00FF41',
      headerBg: 'rgba(13, 2, 8, 0.7)',
      headerIconColor: '#00FF41',
      backgroundGradient1: '#000000',
      backgroundGradient2: '#0D0208',
      backgroundColor1: '#003B00',
      backgroundColor2: '#0D0208',
      textColor1: '#FFFFFF',
      textColor2: '#00FF41',
      borderColor: '#00FF41',
      pointerColor: '#00FF41',
      radiusLineColor: '#003B00'
    }
  },
  {
    id: 'lavender-dreams',
    name: 'Lavanta Rüyası',
    colors: {
      buttonGradient1: '#9B72AA',
      buttonGradient2: '#C6A4CE',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#E6E6FA',
      buttonGlowColor: '#E6E6FA',
      headerBg: 'rgba(155, 114, 170, 0.7)',
      headerIconColor: '#E6E6FA',
      backgroundGradient1: '#4B3B55',
      backgroundGradient2: '#9B72AA',
      backgroundColor1: '#C6A4CE',
      backgroundColor2: '#9B72AA',
      textColor1: '#FFFFFF',
      textColor2: '#F0E6FF',
      borderColor: '#E6E6FA',
      pointerColor: '#E6E6FA',
      radiusLineColor: '#C6A4CE'
    }
  },
  {
    id: 'retro-wave',
    name: 'Retro Dalga',
    colors: {
      buttonGradient1: '#241734',
      buttonGradient2: '#2D1B69',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF00FF',
      buttonGlowColor: '#FF00FF',
      headerBg: 'rgba(36, 23, 52, 0.7)',
      headerIconColor: '#FF00FF',
      backgroundGradient1: '#150D1E',
      backgroundGradient2: '#241734',
      backgroundColor1: '#2D1B69',
      backgroundColor2: '#241734',
      textColor1: '#FFFFFF',
      textColor2: '#FFB8FF',
      borderColor: '#FF00FF',
      pointerColor: '#FF00FF',
      radiusLineColor: '#2D1B69'
    }
  },
  {
    id: 'mint-chocolate',
    name: 'Naneli Çikolata',
    colors: {
      buttonGradient1: '#2D1810',
      buttonGradient2: '#3C2415',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#98FF98',
      buttonGlowColor: '#98FF98',
      headerBg: 'rgba(45, 24, 16, 0.7)',
      headerIconColor: '#98FF98',
      backgroundGradient1: '#1A0F0A',
      backgroundGradient2: '#2D1810',
      backgroundColor1: '#3C2415',
      backgroundColor2: '#2D1810',
      textColor1: '#FFFFFF',
      textColor2: '#CCFFE5',
      borderColor: '#98FF98',
      pointerColor: '#98FF98',
      radiusLineColor: '#3C2415'
    }
  },
  {
    id: 'golden-hour',
    name: 'Altın Saat',
    colors: {
      buttonGradient1: '#B85D1C',
      buttonGradient2: '#D4782E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(184, 93, 28, 0.7)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#7A3E12',
      backgroundGradient2: '#B85D1C',
      backgroundColor1: '#D4782E',
      backgroundColor2: '#B85D1C',
      textColor1: '#FFFFFF',
      textColor2: '#FFE5B4',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#D4782E'
    }
  },
  {
    id: 'midnight-bloom',
    name: 'Gece Çiçeği',
    colors: {
      buttonGradient1: '#2B0F54',
      buttonGradient2: '#3B1578',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#B24BF3',
      buttonGlowColor: '#B24BF3',
      headerBg: 'rgba(43, 15, 84, 0.7)',
      headerIconColor: '#B24BF3',
      backgroundGradient1: '#1A0933',
      backgroundGradient2: '#2B0F54',
      backgroundColor1: '#3B1578',
      backgroundColor2: '#2B0F54',
      textColor1: '#FFFFFF',
      textColor2: '#E5B8FF',
      borderColor: '#B24BF3',
      pointerColor: '#B24BF3',
      radiusLineColor: '#3B1578'
    }
  },
  {
    id: 'buz-kristali',
    name: 'Buz Kristali',
    colors: {
      buttonGradient1: '#0C2A40',
      buttonGradient2: '#1A3D57',
      buttonTextColor: '#E0F7FF',
      buttonBorderColor: '#7DD3FC',
      buttonGlowColor: '#7DD3FC',
      headerBg: 'rgba(12, 42, 64, 0.7)',
      headerIconColor: '#7DD3FC',
      backgroundGradient1: '#060E17',
      backgroundGradient2: '#0C2A40',
      backgroundColor1: '#1A3D57',
      backgroundColor2: '#0C2A40',
      textColor1: '#E0F7FF',
      textColor2: '#BAE6FD',
      borderColor: '#7DD3FC',
      pointerColor: '#7DD3FC',
      radiusLineColor: '#1A3D57'
    }
  },
  {
    id: 'neon-pembe',
    name: 'Neon Pembe',
    colors: {
      buttonGradient1: '#1F0015',
      buttonGradient2: '#320020',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF006E',
      buttonGlowColor: '#FF006E',
      headerBg: 'rgba(31, 0, 21, 0.7)',
      headerIconColor: '#FF006E',
      backgroundGradient1: '#0F000A',
      backgroundGradient2: '#1F0015',
      backgroundColor1: '#320020',
      backgroundColor2: '#1F0015',
      textColor1: '#FFFFFF',
      textColor2: '#FFB3D9',
      borderColor: '#FF006E',
      pointerColor: '#FF006E',
      radiusLineColor: '#320020'
    }
  },
  {
    id: 'yildiz-tozu',
    name: 'Yıldız Tozu',
    colors: {
      buttonGradient1: '#0E0A20',
      buttonGradient2: '#1A1535',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#C4B5FD',
      buttonGlowColor: '#C4B5FD',
      headerBg: 'rgba(14, 10, 32, 0.7)',
      headerIconColor: '#C4B5FD',
      backgroundGradient1: '#050310',
      backgroundGradient2: '#0E0A20',
      backgroundColor1: '#1A1535',
      backgroundColor2: '#0E0A20',
      textColor1: '#FFFFFF',
      textColor2: '#DDD6FE',
      borderColor: '#C4B5FD',
      pointerColor: '#C4B5FD',
      radiusLineColor: '#1A1535'
    }
  },
  {
    id: 'kiremit',
    name: 'Kiremit',
    colors: {
      buttonGradient1: '#3D1C0A',
      buttonGradient2: '#562A10',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#E07048',
      buttonGlowColor: '#E07048',
      headerBg: 'rgba(61, 28, 10, 0.7)',
      headerIconColor: '#E07048',
      backgroundGradient1: '#221002',
      backgroundGradient2: '#3D1C0A',
      backgroundColor1: '#562A10',
      backgroundColor2: '#3D1C0A',
      textColor1: '#FFFFFF',
      textColor2: '#FFCBA4',
      borderColor: '#E07048',
      pointerColor: '#E07048',
      radiusLineColor: '#562A10'
    }
  },
  {
    id: 'indigo-cosmos',
    name: 'İndigo Kozmos',
    colors: {
      buttonGradient1: '#1E1B4B',
      buttonGradient2: '#312E81',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#818CF8',
      buttonGlowColor: '#818CF8',
      headerBg: 'rgba(30, 27, 75, 0.7)',
      headerIconColor: '#818CF8',
      backgroundGradient1: '#0D0B28',
      backgroundGradient2: '#1E1B4B',
      backgroundColor1: '#312E81',
      backgroundColor2: '#1E1B4B',
      textColor1: '#FFFFFF',
      textColor2: '#C7D2FE',
      borderColor: '#818CF8',
      pointerColor: '#818CF8',
      radiusLineColor: '#312E81'
    }
  },
  {
    id: 'asit-lime',
    name: 'Asit Lime',
    colors: {
      buttonGradient1: '#0D1A00',
      buttonGradient2: '#1A2D00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#A3FF00',
      buttonGlowColor: '#A3FF00',
      headerBg: 'rgba(13, 26, 0, 0.7)',
      headerIconColor: '#A3FF00',
      backgroundGradient1: '#060D00',
      backgroundGradient2: '#0D1A00',
      backgroundColor1: '#1A2D00',
      backgroundColor2: '#0D1A00',
      textColor1: '#FFFFFF',
      textColor2: '#D9FF99',
      borderColor: '#A3FF00',
      pointerColor: '#A3FF00',
      radiusLineColor: '#1A2D00'
    }
  },
  {
    id: 'gul-altini',
    name: 'Gül Altını',
    colors: {
      buttonGradient1: '#2D1520',
      buttonGradient2: '#3F1D2E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#F4A3B5',
      buttonGlowColor: '#F4A3B5',
      headerBg: 'rgba(45, 21, 32, 0.7)',
      headerIconColor: '#F4A3B5',
      backgroundGradient1: '#1A0B13',
      backgroundGradient2: '#2D1520',
      backgroundColor1: '#3F1D2E',
      backgroundColor2: '#2D1520',
      textColor1: '#FFFFFF',
      textColor2: '#FADADD',
      borderColor: '#F4A3B5',
      pointerColor: '#F4A3B5',
      radiusLineColor: '#3F1D2E'
    }
  },
  {
    id: 'kan-ayi',
    name: 'Kan Ayı',
    colors: {
      buttonGradient1: '#1F0003',
      buttonGradient2: '#330005',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#CC1122',
      buttonGlowColor: '#CC1122',
      headerBg: 'rgba(31, 0, 3, 0.7)',
      headerIconColor: '#CC1122',
      backgroundGradient1: '#0F0002',
      backgroundGradient2: '#1F0003',
      backgroundColor1: '#330005',
      backgroundColor2: '#1F0003',
      textColor1: '#FFFFFF',
      textColor2: '#FFAAAA',
      borderColor: '#CC1122',
      pointerColor: '#CC1122',
      radiusLineColor: '#330005'
    }
  },
  {
    id: 'yesim-tapinagi',
    name: 'Yeşim Tapınağı',
    colors: {
      buttonGradient1: '#003322',
      buttonGradient2: '#004D33',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00C896',
      buttonGlowColor: '#00C896',
      headerBg: 'rgba(0, 51, 34, 0.7)',
      headerIconColor: '#00C896',
      backgroundGradient1: '#001A11',
      backgroundGradient2: '#003322',
      backgroundColor1: '#004D33',
      backgroundColor2: '#003322',
      textColor1: '#FFFFFF',
      textColor2: '#B3FFE8',
      borderColor: '#00C896',
      pointerColor: '#00C896',
      radiusLineColor: '#004D33'
    }
  },
  {
    id: 'kobalt-mavisi',
    name: 'Kobalt Mavisi',
    colors: {
      buttonGradient1: '#003380',
      buttonGradient2: '#0044AA',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#55AAFF',
      buttonGlowColor: '#55AAFF',
      headerBg: 'rgba(0, 51, 128, 0.7)',
      headerIconColor: '#55AAFF',
      backgroundGradient1: '#001540',
      backgroundGradient2: '#003380',
      backgroundColor1: '#0044AA',
      backgroundColor2: '#003380',
      textColor1: '#FFFFFF',
      textColor2: '#CCE5FF',
      borderColor: '#55AAFF',
      pointerColor: '#55AAFF',
      radiusLineColor: '#0044AA'
    }
  },
  {
    id: 'elektrik-viyole',
    name: 'Elektrik Viyole',
    colors: {
      buttonGradient1: '#150028',
      buttonGradient2: '#220040',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#AA00FF',
      buttonGlowColor: '#AA00FF',
      headerBg: 'rgba(21, 0, 40, 0.7)',
      headerIconColor: '#AA00FF',
      backgroundGradient1: '#0A0015',
      backgroundGradient2: '#150028',
      backgroundColor1: '#220040',
      backgroundColor2: '#150028',
      textColor1: '#FFFFFF',
      textColor2: '#E5AAFF',
      borderColor: '#AA00FF',
      pointerColor: '#AA00FF',
      radiusLineColor: '#220040'
    }
  },
  {
    id: 'firtina-gece',
    name: 'Fırtına Gecesi',
    colors: {
      buttonGradient1: '#0D1117',
      buttonGradient2: '#161B22',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#4F46E5',
      buttonGlowColor: '#4F46E5',
      headerBg: 'rgba(13, 17, 23, 0.7)',
      headerIconColor: '#4F46E5',
      backgroundGradient1: '#060B10',
      backgroundGradient2: '#0D1117',
      backgroundColor1: '#161B22',
      backgroundColor2: '#0D1117',
      textColor1: '#FFFFFF',
      textColor2: '#A5B4FC',
      borderColor: '#4F46E5',
      pointerColor: '#4F46E5',
      radiusLineColor: '#161B22'
    }
  },
  {
    id: 'seker-pembe',
    name: 'Şeker Pembe',
    colors: {
      buttonGradient1: '#2D0020',
      buttonGradient2: '#450030',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF69B4',
      buttonGlowColor: '#FF69B4',
      headerBg: 'rgba(45, 0, 32, 0.7)',
      headerIconColor: '#FF69B4',
      backgroundGradient1: '#180010',
      backgroundGradient2: '#2D0020',
      backgroundColor1: '#450030',
      backgroundColor2: '#2D0020',
      textColor1: '#FFFFFF',
      textColor2: '#FFB3D9',
      borderColor: '#FF69B4',
      pointerColor: '#FF69B4',
      radiusLineColor: '#450030'
    }
  },
  {
    id: 'derin-uzay',
    name: 'Derin Uzay',
    colors: {
      buttonGradient1: '#03050F',
      buttonGradient2: '#070A1A',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00D4FF',
      buttonGlowColor: '#00D4FF',
      headerBg: 'rgba(3, 5, 15, 0.7)',
      headerIconColor: '#00D4FF',
      backgroundGradient1: '#010208',
      backgroundGradient2: '#03050F',
      backgroundColor1: '#070A1A',
      backgroundColor2: '#03050F',
      textColor1: '#FFFFFF',
      textColor2: '#99EEFF',
      borderColor: '#00D4FF',
      pointerColor: '#00D4FF',
      radiusLineColor: '#070A1A'
    }
  },
  {
    id: 'neon-turuncu',
    name: 'Neon Turuncu',
    colors: {
      buttonGradient1: '#1F0E00',
      buttonGradient2: '#331800',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF6B00',
      buttonGlowColor: '#FF6B00',
      headerBg: 'rgba(31, 14, 0, 0.7)',
      headerIconColor: '#FF6B00',
      backgroundGradient1: '#100700',
      backgroundGradient2: '#1F0E00',
      backgroundColor1: '#331800',
      backgroundColor2: '#1F0E00',
      textColor1: '#FFFFFF',
      textColor2: '#FFCC99',
      borderColor: '#FF6B00',
      pointerColor: '#FF6B00',
      radiusLineColor: '#331800'
    }
  },
  {
    id: 'neon-aqua',
    name: 'Neon Aqua',
    colors: {
      buttonGradient1: '#001F28',
      buttonGradient2: '#003040',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00E5FF',
      buttonGlowColor: '#00E5FF',
      headerBg: 'rgba(0, 31, 40, 0.7)',
      headerIconColor: '#00E5FF',
      backgroundGradient1: '#000F14',
      backgroundGradient2: '#001F28',
      backgroundColor1: '#003040',
      backgroundColor2: '#001F28',
      textColor1: '#FFFFFF',
      textColor2: '#99F3FF',
      borderColor: '#00E5FF',
      pointerColor: '#00E5FF',
      radiusLineColor: '#003040'
    }
  },
  {
    id: 'gece-eflatun',
    name: 'Gece Eflatun',
    colors: {
      buttonGradient1: '#1F0033',
      buttonGradient2: '#330050',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#DA70D6',
      buttonGlowColor: '#DA70D6',
      headerBg: 'rgba(31, 0, 51, 0.7)',
      headerIconColor: '#DA70D6',
      backgroundGradient1: '#10001A',
      backgroundGradient2: '#1F0033',
      backgroundColor1: '#330050',
      backgroundColor2: '#1F0033',
      textColor1: '#FFFFFF',
      textColor2: '#F0AAEE',
      borderColor: '#DA70D6',
      pointerColor: '#DA70D6',
      radiusLineColor: '#330050'
    }
  },
  {
    id: 'bronz-cag',
    name: 'Bronz Çağ',
    colors: {
      buttonGradient1: '#2A1A08',
      buttonGradient2: '#3D2610',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#CD7F32',
      buttonGlowColor: '#CD7F32',
      headerBg: 'rgba(42, 26, 8, 0.7)',
      headerIconColor: '#CD7F32',
      backgroundGradient1: '#170D04',
      backgroundGradient2: '#2A1A08',
      backgroundColor1: '#3D2610',
      backgroundColor2: '#2A1A08',
      textColor1: '#FFFFFF',
      textColor2: '#F5D09A',
      borderColor: '#CD7F32',
      pointerColor: '#CD7F32',
      radiusLineColor: '#3D2610'
    }
  },
  {
    id: 'mor-alev',
    name: 'Mor Alev',
    colors: {
      buttonGradient1: '#1A0030',
      buttonGradient2: '#2D0050',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#CC00FF',
      buttonGlowColor: '#CC00FF',
      headerBg: 'rgba(26, 0, 48, 0.7)',
      headerIconColor: '#CC00FF',
      backgroundGradient1: '#0D0018',
      backgroundGradient2: '#1A0030',
      backgroundColor1: '#2D0050',
      backgroundColor2: '#1A0030',
      textColor1: '#FFFFFF',
      textColor2: '#EE99FF',
      borderColor: '#CC00FF',
      pointerColor: '#CC00FF',
      radiusLineColor: '#2D0050'
    }
  },
  {
    id: 'mercan-resifi',
    name: 'Mercan Resifi',
    colors: {
      buttonGradient1: '#00282A',
      buttonGradient2: '#003D40',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF7F50',
      buttonGlowColor: '#FF7F50',
      headerBg: 'rgba(0, 40, 42, 0.7)',
      headerIconColor: '#FF7F50',
      backgroundGradient1: '#001415',
      backgroundGradient2: '#00282A',
      backgroundColor1: '#003D40',
      backgroundColor2: '#00282A',
      textColor1: '#FFFFFF',
      textColor2: '#FFCCBB',
      borderColor: '#FF7F50',
      pointerColor: '#FF7F50',
      radiusLineColor: '#003D40'
    }
  },
  {
    id: 'altin-cag',
    name: 'Altın Çağ',
    colors: {
      buttonGradient1: '#1A1200',
      buttonGradient2: '#2D1E00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#F0A500',
      buttonGlowColor: '#F0A500',
      headerBg: 'rgba(26, 18, 0, 0.7)',
      headerIconColor: '#F0A500',
      backgroundGradient1: '#0D0900',
      backgroundGradient2: '#1A1200',
      backgroundColor1: '#2D1E00',
      backgroundColor2: '#1A1200',
      textColor1: '#FFFFFF',
      textColor2: '#FFE0AA',
      borderColor: '#F0A500',
      pointerColor: '#F0A500',
      radiusLineColor: '#2D1E00'
    }
  },
  {
    id: 'pasifik-mavi',
    name: 'Pasifik Mavisi',
    colors: {
      buttonGradient1: '#003380',
      buttonGradient2: '#0044AA',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#66BBFF',
      buttonGlowColor: '#66BBFF',
      headerBg: 'rgba(0, 51, 128, 0.7)',
      headerIconColor: '#66BBFF',
      backgroundGradient1: '#001540',
      backgroundGradient2: '#002266',
      backgroundColor1: '#0044AA',
      backgroundColor2: '#003380',
      textColor1: '#FFFFFF',
      textColor2: '#CCE8FF',
      borderColor: '#66BBFF',
      pointerColor: '#66BBFF',
      radiusLineColor: '#0044AA'
    }
  },
  {
    id: 'limon-neon',
    name: 'Limon Neon',
    colors: {
      buttonGradient1: '#1A1A00',
      buttonGradient2: '#2D2D00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#F5E642',
      buttonGlowColor: '#F5E642',
      headerBg: 'rgba(26, 26, 0, 0.7)',
      headerIconColor: '#F5E642',
      backgroundGradient1: '#0D0D00',
      backgroundGradient2: '#1A1A00',
      backgroundColor1: '#2D2D00',
      backgroundColor2: '#1A1A00',
      textColor1: '#FFFFFF',
      textColor2: '#FFFF99',
      borderColor: '#F5E642',
      pointerColor: '#F5E642',
      radiusLineColor: '#2D2D00'
    }
  },
  {
    id: 'elmas',
    name: 'Elmas',
    colors: {
      buttonGradient1: '#0A1020',
      buttonGradient2: '#141E33',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#B9F2FF',
      buttonGlowColor: '#B9F2FF',
      headerBg: 'rgba(10, 16, 32, 0.7)',
      headerIconColor: '#B9F2FF',
      backgroundGradient1: '#050810',
      backgroundGradient2: '#0A1020',
      backgroundColor1: '#141E33',
      backgroundColor2: '#0A1020',
      textColor1: '#FFFFFF',
      textColor2: '#DCF5FF',
      borderColor: '#B9F2FF',
      pointerColor: '#B9F2FF',
      radiusLineColor: '#141E33'
    }
  },
  {
    id: 'titan-gri',
    name: 'Titan Grisi',
    colors: {
      buttonGradient1: '#1C1C24',
      buttonGradient2: '#2A2A35',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#A0B0C0',
      buttonGlowColor: '#A0B0C0',
      headerBg: 'rgba(28, 28, 36, 0.7)',
      headerIconColor: '#A0B0C0',
      backgroundGradient1: '#0E0E14',
      backgroundGradient2: '#1C1C24',
      backgroundColor1: '#2A2A35',
      backgroundColor2: '#1C1C24',
      textColor1: '#FFFFFF',
      textColor2: '#C5CDD6',
      borderColor: '#A0B0C0',
      pointerColor: '#A0B0C0',
      radiusLineColor: '#2A2A35'
    }
  },
  {
    id: 'sirius-yildizi',
    name: 'Sirius Yıldızı',
    colors: {
      buttonGradient1: '#001833',
      buttonGradient2: '#002447',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#4FC3F7',
      buttonGlowColor: '#4FC3F7',
      headerBg: 'rgba(0, 24, 51, 0.7)',
      headerIconColor: '#4FC3F7',
      backgroundGradient1: '#000C1A',
      backgroundGradient2: '#001833',
      backgroundColor1: '#002447',
      backgroundColor2: '#001833',
      textColor1: '#FFFFFF',
      textColor2: '#B3E8FF',
      borderColor: '#4FC3F7',
      pointerColor: '#4FC3F7',
      radiusLineColor: '#002447'
    }
  },
  {
    id: 'pembe-alev',
    name: 'Pembe Alev',
    colors: {
      buttonGradient1: '#1A0010',
      buttonGradient2: '#2D001A',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF4488',
      buttonGlowColor: '#FF4488',
      headerBg: 'rgba(26, 0, 16, 0.7)',
      headerIconColor: '#FF4488',
      backgroundGradient1: '#0D0008',
      backgroundGradient2: '#1A0010',
      backgroundColor1: '#2D001A',
      backgroundColor2: '#1A0010',
      textColor1: '#FFFFFF',
      textColor2: '#FFAABB',
      borderColor: '#FF4488',
      pointerColor: '#FF4488',
      radiusLineColor: '#2D001A'
    }
  },
  {
    id: 'selvi-yesili',
    name: 'Selvi Yeşili',
    colors: {
      buttonGradient1: '#0A1F0A',
      buttonGradient2: '#142814',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#4CAF50',
      buttonGlowColor: '#4CAF50',
      headerBg: 'rgba(10, 31, 10, 0.7)',
      headerIconColor: '#4CAF50',
      backgroundGradient1: '#050F05',
      backgroundGradient2: '#0A1F0A',
      backgroundColor1: '#142814',
      backgroundColor2: '#0A1F0A',
      textColor1: '#FFFFFF',
      textColor2: '#B8F0B8',
      borderColor: '#4CAF50',
      pointerColor: '#4CAF50',
      radiusLineColor: '#142814'
    }
  },
  {
    id: 'sahara',
    name: 'Sahara',
    colors: {
      buttonGradient1: '#3D2A00',
      buttonGradient2: '#5A3D00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFAB40',
      buttonGlowColor: '#FFAB40',
      headerBg: 'rgba(61, 42, 0, 0.7)',
      headerIconColor: '#FFAB40',
      backgroundGradient1: '#1F1500',
      backgroundGradient2: '#3D2A00',
      backgroundColor1: '#5A3D00',
      backgroundColor2: '#3D2A00',
      textColor1: '#FFFFFF',
      textColor2: '#FFE0AA',
      borderColor: '#FFAB40',
      pointerColor: '#FFAB40',
      radiusLineColor: '#5A3D00'
    }
  },
  {
    id: 'buzul',
    name: 'Buzul',
    colors: {
      buttonGradient1: '#071B24',
      buttonGradient2: '#0F2A37',
      buttonTextColor: '#E0F8FF',
      buttonBorderColor: '#67E8F9',
      buttonGlowColor: '#67E8F9',
      headerBg: 'rgba(7, 27, 36, 0.7)',
      headerIconColor: '#67E8F9',
      backgroundGradient1: '#030C12',
      backgroundGradient2: '#071B24',
      backgroundColor1: '#0F2A37',
      backgroundColor2: '#071B24',
      textColor1: '#E0F8FF',
      textColor2: '#A5F3FC',
      borderColor: '#67E8F9',
      pointerColor: '#67E8F9',
      radiusLineColor: '#0F2A37'
    }
  },
  {
    id: 'alacakaranlik',
    name: 'Alacakaranlık',
    colors: {
      buttonGradient1: '#1F0A28',
      buttonGradient2: '#331545',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF7043',
      buttonGlowColor: '#FF7043',
      headerBg: 'rgba(31, 10, 40, 0.7)',
      headerIconColor: '#FF7043',
      backgroundGradient1: '#100515',
      backgroundGradient2: '#1F0A28',
      backgroundColor1: '#331545',
      backgroundColor2: '#1F0A28',
      textColor1: '#FFFFFF',
      textColor2: '#FFCCBB',
      borderColor: '#FF7043',
      pointerColor: '#FF7043',
      radiusLineColor: '#331545'
    }
  },
  {
    id: 'deniz-yosunu',
    name: 'Deniz Yosunu',
    colors: {
      buttonGradient1: '#0A1A12',
      buttonGradient2: '#14281C',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#6BAF7E',
      buttonGlowColor: '#6BAF7E',
      headerBg: 'rgba(10, 26, 18, 0.7)',
      headerIconColor: '#6BAF7E',
      backgroundGradient1: '#050D09',
      backgroundGradient2: '#0A1A12',
      backgroundColor1: '#14281C',
      backgroundColor2: '#0A1A12',
      textColor1: '#FFFFFF',
      textColor2: '#B8D9C5',
      borderColor: '#6BAF7E',
      pointerColor: '#6BAF7E',
      radiusLineColor: '#14281C'
    }
  },
  {
    id: 'kayan-yildiz',
    name: 'Kayan Yıldız',
    colors: {
      buttonGradient1: '#080814',
      buttonGradient2: '#0F0F20',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#F0F0FF',
      buttonGlowColor: '#F0F0FF',
      headerBg: 'rgba(8, 8, 20, 0.7)',
      headerIconColor: '#F0F0FF',
      backgroundGradient1: '#040408',
      backgroundGradient2: '#080814',
      backgroundColor1: '#0F0F20',
      backgroundColor2: '#080814',
      textColor1: '#FFFFFF',
      textColor2: '#DDDDFF',
      borderColor: '#F0F0FF',
      pointerColor: '#F0F0FF',
      radiusLineColor: '#0F0F20'
    }
  },
  {
    id: 'gece-meneksesi',
    name: 'Gece Menekşesi',
    colors: {
      buttonGradient1: '#150025',
      buttonGradient2: '#220038',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#9B59B6',
      buttonGlowColor: '#9B59B6',
      headerBg: 'rgba(21, 0, 37, 0.7)',
      headerIconColor: '#9B59B6',
      backgroundGradient1: '#0A0012',
      backgroundGradient2: '#150025',
      backgroundColor1: '#220038',
      backgroundColor2: '#150025',
      textColor1: '#FFFFFF',
      textColor2: '#D7AAF0',
      borderColor: '#9B59B6',
      pointerColor: '#9B59B6',
      radiusLineColor: '#220038'
    }
  },
  {
    id: 'kor-kirmizi',
    name: 'Kor Kırmızısı',
    colors: {
      buttonGradient1: '#2A0500',
      buttonGradient2: '#3D0800',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF3300',
      buttonGlowColor: '#FF3300',
      headerBg: 'rgba(42, 5, 0, 0.7)',
      headerIconColor: '#FF3300',
      backgroundGradient1: '#150200',
      backgroundGradient2: '#2A0500',
      backgroundColor1: '#3D0800',
      backgroundColor2: '#2A0500',
      textColor1: '#FFFFFF',
      textColor2: '#FFAA99',
      borderColor: '#FF3300',
      pointerColor: '#FF3300',
      radiusLineColor: '#3D0800'
    }
  },
  {
    id: 'opal',
    name: 'Opal',
    colors: {
      buttonGradient1: '#1A1528',
      buttonGradient2: '#261E38',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#A8C5DA',
      buttonGlowColor: '#A8C5DA',
      headerBg: 'rgba(26, 21, 40, 0.7)',
      headerIconColor: '#A8C5DA',
      backgroundGradient1: '#0D0A14',
      backgroundGradient2: '#1A1528',
      backgroundColor1: '#261E38',
      backgroundColor2: '#1A1528',
      textColor1: '#FFFFFF',
      textColor2: '#D4E8F5',
      borderColor: '#A8C5DA',
      pointerColor: '#A8C5DA',
      radiusLineColor: '#261E38'
    }
  }
];

const betThemes = [
  {
    id: 'vegas-nights',
    name: 'Vegas Nights',
    category: 'bet',
    colors: {
      buttonGradient1: '#1F1F1F',
      buttonGradient2: '#2C2C2C',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(31, 31, 31, 0.8)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#000000',
      backgroundGradient2: '#1A1A1A',
      backgroundColor1: '#2C2C2C',
      backgroundColor2: '#1F1F1F',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#2C2C2C'
    }
  },
  {
    id: 'ruby-fortune',
    name: 'Ruby Fortune',
    category: 'bet',
    colors: {
      buttonGradient1: '#8B0000',
      buttonGradient2: '#A31545',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF1493',
      buttonGlowColor: '#FF1493',
      headerBg: 'rgba(139, 0, 0, 0.8)',
      headerIconColor: '#FF1493',
      backgroundGradient1: '#2B0000',
      backgroundGradient2: '#4A0000',
      backgroundColor1: '#A31545',
      backgroundColor2: '#8B0000',
      textColor1: '#FFFFFF',
      textColor2: '#FFB6C1',
      borderColor: '#FF1493',
      pointerColor: '#FF1493',
      radiusLineColor: '#A31545'
    }
  },
  {
    id: 'neon-casino',
    name: 'Neon Casino',
    category: 'bet',
    colors: {
      buttonGradient1: '#2E0854',
      buttonGradient2: '#4B0082',
      buttonTextColor: '#00FFFF',
      buttonBorderColor: '#00FFFF',
      buttonGlowColor: '#00FFFF',
      headerBg: 'rgba(46, 8, 84, 0.8)',
      headerIconColor: '#00FFFF',
      backgroundGradient1: '#1A0033',
      backgroundGradient2: '#2E0854',
      backgroundColor1: '#4B0082',
      backgroundColor2: '#2E0854',
      textColor1: '#00FFFF',
      textColor2: '#FFFFFF',
      borderColor: '#00FFFF',
      pointerColor: '#00FFFF',
      radiusLineColor: '#4B0082'
    }
  },
  {
    id: 'golden-palace',
    name: 'Golden Palace',
    category: 'bet',
    colors: {
      buttonGradient1: '#B8860B',
      buttonGradient2: '#DAA520',
      buttonTextColor: '#000000',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(184, 134, 11, 0.8)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#4C3800',
      backgroundGradient2: '#705800',
      backgroundColor1: '#DAA520',
      backgroundColor2: '#B8860B',
      textColor1: '#000000',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#DAA520'
    }
  },
  {
    id: 'emerald-bet',
    name: 'Emerald Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#004D40',
      buttonGradient2: '#00695C',
      buttonTextColor: '#00FF9D',
      buttonBorderColor: '#00FF9D',
      buttonGlowColor: '#00FF9D',
      headerBg: 'rgba(0, 77, 64, 0.8)',
      headerIconColor: '#00FF9D',
      backgroundGradient1: '#001F1A',
      backgroundGradient2: '#004D40',
      backgroundColor1: '#00695C',
      backgroundColor2: '#004D40',
      textColor1: '#00FF9D',
      textColor2: '#FFFFFF',
      borderColor: '#00FF9D',
      pointerColor: '#00FF9D',
      radiusLineColor: '#00695C'
    }
  },
  {
    id: 'royal-flush',
    name: 'Royal Flush',
    category: 'bet',
    colors: {
      buttonGradient1: '#4A148C',
      buttonGradient2: '#6A1B9A',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#E1BEE7',
      buttonGlowColor: '#E1BEE7',
      headerBg: 'rgba(74, 20, 140, 0.8)',
      headerIconColor: '#E1BEE7',
      backgroundGradient1: '#2A0B50',
      backgroundGradient2: '#4A148C',
      backgroundColor1: '#6A1B9A',
      backgroundColor2: '#4A148C',
      textColor1: '#FFFFFF',
      textColor2: '#E1BEE7',
      borderColor: '#E1BEE7',
      pointerColor: '#E1BEE7',
      radiusLineColor: '#6A1B9A'
    }
  },
  {
    id: 'lucky-dragon',
    name: 'Lucky Dragon',
    category: 'bet',
    colors: {
      buttonGradient1: '#B71C1C',
      buttonGradient2: '#C62828',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(183, 28, 28, 0.8)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#4A0404',
      backgroundGradient2: '#8B0000',
      backgroundColor1: '#C62828',
      backgroundColor2: '#B71C1C',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#C62828'
    }
  },
  {
    id: 'cyber-bet',
    name: 'Cyber Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A237E',
      buttonGradient2: '#283593',
      buttonTextColor: '#00FFFF',
      buttonBorderColor: '#00FFFF',
      buttonGlowColor: '#00FFFF',
      headerBg: 'rgba(26, 35, 126, 0.8)',
      headerIconColor: '#00FFFF',
      backgroundGradient1: '#0D1042',
      backgroundGradient2: '#1A237E',
      backgroundColor1: '#283593',
      backgroundColor2: '#1A237E',
      textColor1: '#00FFFF',
      textColor2: '#FFFFFF',
      borderColor: '#00FFFF',
      pointerColor: '#00FFFF',
      radiusLineColor: '#283593'
    }
  },
  {
    id: 'diamond-club',
    name: 'Diamond Club',
    category: 'bet',
    colors: {
      buttonGradient1: '#0D47A1',
      buttonGradient2: '#1565C0',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#40C4FF',
      buttonGlowColor: '#40C4FF',
      headerBg: 'rgba(13, 71, 161, 0.8)',
      headerIconColor: '#40C4FF',
      backgroundGradient1: '#031A3B',
      backgroundGradient2: '#0D47A1',
      backgroundColor1: '#1565C0',
      backgroundColor2: '#0D47A1',
      textColor1: '#FFFFFF',
      textColor2: '#B3E5FC',
      borderColor: '#40C4FF',
      pointerColor: '#40C4FF',
      radiusLineColor: '#1565C0'
    }
  },
  {
    id: 'platinum-vip',
    name: 'Platinum VIP',
    category: 'bet',
    colors: {
      buttonGradient1: '#424242',
      buttonGradient2: '#616161',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#E0E0E0',
      buttonGlowColor: '#E0E0E0',
      headerBg: 'rgba(66, 66, 66, 0.8)',
      headerIconColor: '#E0E0E0',
      backgroundGradient1: '#212121',
      backgroundGradient2: '#424242',
      backgroundColor1: '#616161',
      backgroundColor2: '#424242',
      textColor1: '#FFFFFF',
      textColor2: '#E0E0E0',
      borderColor: '#E0E0E0',
      pointerColor: '#E0E0E0',
      radiusLineColor: '#616161'
    }
  },
  {
    id: 'black-jack',
    name: 'Black Jack',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A0A0A',
      buttonGradient2: '#141414',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(10, 10, 10, 0.9)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#000000',
      backgroundGradient2: '#0A0A0A',
      backgroundColor1: '#141414',
      backgroundColor2: '#0A0A0A',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#141414'
    }
  },
  {
    id: 'poker-table',
    name: 'Poker Table',
    category: 'bet',
    colors: {
      buttonGradient1: '#0D3B1F',
      buttonGradient2: '#155230',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(13, 59, 31, 0.9)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#061A0D',
      backgroundGradient2: '#0D3B1F',
      backgroundColor1: '#155230',
      backgroundColor2: '#0D3B1F',
      textColor1: '#FFFFFF',
      textColor2: '#FFE5A0',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#155230'
    }
  },
  {
    id: 'roulette',
    name: 'Roulette',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A0000',
      buttonGradient2: '#2D0000',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF3333',
      buttonGlowColor: '#FF3333',
      headerBg: 'rgba(26, 0, 0, 0.9)',
      headerIconColor: '#FF3333',
      backgroundGradient1: '#0D0000',
      backgroundGradient2: '#1A0000',
      backgroundColor1: '#2D0000',
      backgroundColor2: '#1A0000',
      textColor1: '#FFFFFF',
      textColor2: '#FFAAAA',
      borderColor: '#FF3333',
      pointerColor: '#FF3333',
      radiusLineColor: '#2D0000'
    }
  },
  {
    id: 'slot-machine',
    name: 'Slot Machine',
    category: 'bet',
    colors: {
      buttonGradient1: '#1F0D33',
      buttonGradient2: '#2D1A45',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF00AA',
      buttonGlowColor: '#FF00AA',
      headerBg: 'rgba(31, 13, 51, 0.9)',
      headerIconColor: '#FF00AA',
      backgroundGradient1: '#0F0618',
      backgroundGradient2: '#1F0D33',
      backgroundColor1: '#2D1A45',
      backgroundColor2: '#1F0D33',
      textColor1: '#FFFFFF',
      textColor2: '#FFAADD',
      borderColor: '#FF00AA',
      pointerColor: '#FF00AA',
      radiusLineColor: '#2D1A45'
    }
  },
  {
    id: 'baccarat',
    name: 'Baccarat',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A0A14',
      buttonGradient2: '#14141E',
      buttonTextColor: '#C0A060',
      buttonBorderColor: '#C0A060',
      buttonGlowColor: '#C0A060',
      headerBg: 'rgba(10, 10, 20, 0.9)',
      headerIconColor: '#C0A060',
      backgroundGradient1: '#050508',
      backgroundGradient2: '#0A0A14',
      backgroundColor1: '#14141E',
      backgroundColor2: '#0A0A14',
      textColor1: '#C0A060',
      textColor2: '#FFFFFF',
      borderColor: '#C0A060',
      pointerColor: '#C0A060',
      radiusLineColor: '#14141E'
    }
  },
  {
    id: 'high-roller',
    name: 'High Roller',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A1A1A',
      buttonGradient2: '#252525',
      buttonTextColor: '#E5C26A',
      buttonBorderColor: '#E5C26A',
      buttonGlowColor: '#E5C26A',
      headerBg: 'rgba(26, 26, 26, 0.9)',
      headerIconColor: '#E5C26A',
      backgroundGradient1: '#0A0A0A',
      backgroundGradient2: '#1A1A1A',
      backgroundColor1: '#252525',
      backgroundColor2: '#1A1A1A',
      textColor1: '#FFFFFF',
      textColor2: '#E5C26A',
      borderColor: '#E5C26A',
      pointerColor: '#E5C26A',
      radiusLineColor: '#252525'
    }
  },
  {
    id: 'fortune-tiger',
    name: 'Fortune Tiger',
    category: 'bet',
    colors: {
      buttonGradient1: '#7B2800',
      buttonGradient2: '#A63C00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF8C00',
      buttonGlowColor: '#FF8C00',
      headerBg: 'rgba(123, 40, 0, 0.9)',
      headerIconColor: '#FF8C00',
      backgroundGradient1: '#3D1400',
      backgroundGradient2: '#6B2200',
      backgroundColor1: '#A63C00',
      backgroundColor2: '#7B2800',
      textColor1: '#FFFFFF',
      textColor2: '#FFCC88',
      borderColor: '#FF8C00',
      pointerColor: '#FF8C00',
      radiusLineColor: '#A63C00'
    }
  },
  {
    id: 'dice-master',
    name: 'Dice Master',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A1A1A',
      buttonGradient2: '#2D2D2D',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF4444',
      buttonGlowColor: '#FF4444',
      headerBg: 'rgba(26, 26, 26, 0.9)',
      headerIconColor: '#FF4444',
      backgroundGradient1: '#0A0A0A',
      backgroundGradient2: '#1A1A1A',
      backgroundColor1: '#2D2D2D',
      backgroundColor2: '#1A1A1A',
      textColor1: '#FFFFFF',
      textColor2: '#FFAAAA',
      borderColor: '#FF4444',
      pointerColor: '#FF4444',
      radiusLineColor: '#2D2D2D'
    }
  },
  {
    id: 'crown-casino',
    name: 'Crown Casino',
    category: 'bet',
    colors: {
      buttonGradient1: '#0F0030',
      buttonGradient2: '#1A0050',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(15, 0, 48, 0.9)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#080018',
      backgroundGradient2: '#0F0030',
      backgroundColor1: '#1A0050',
      backgroundColor2: '#0F0030',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#1A0050'
    }
  },
  {
    id: 'wild-west',
    name: 'Wild West',
    category: 'bet',
    colors: {
      buttonGradient1: '#3D2200',
      buttonGradient2: '#5A3300',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#D4881A',
      buttonGlowColor: '#D4881A',
      headerBg: 'rgba(61, 34, 0, 0.9)',
      headerIconColor: '#D4881A',
      backgroundGradient1: '#1F1100',
      backgroundGradient2: '#3D2200',
      backgroundColor1: '#5A3300',
      backgroundColor2: '#3D2200',
      textColor1: '#FFFFFF',
      textColor2: '#F5CAAA',
      borderColor: '#D4881A',
      pointerColor: '#D4881A',
      radiusLineColor: '#5A3300'
    }
  },
  {
    id: 'monte-carlo',
    name: 'Monte Carlo',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A1428',
      buttonGradient2: '#141E3D',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#B8C8E0',
      buttonGlowColor: '#B8C8E0',
      headerBg: 'rgba(10, 20, 40, 0.9)',
      headerIconColor: '#B8C8E0',
      backgroundGradient1: '#050A14',
      backgroundGradient2: '#0A1428',
      backgroundColor1: '#141E3D',
      backgroundColor2: '#0A1428',
      textColor1: '#FFFFFF',
      textColor2: '#C8D8F0',
      borderColor: '#B8C8E0',
      pointerColor: '#B8C8E0',
      radiusLineColor: '#141E3D'
    }
  },
  {
    id: 'jackpot-city',
    name: 'Jackpot City',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A1200',
      buttonGradient2: '#2D1F00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFB800',
      buttonGlowColor: '#FFB800',
      headerBg: 'rgba(26, 18, 0, 0.9)',
      headerIconColor: '#FFB800',
      backgroundGradient1: '#0D0900',
      backgroundGradient2: '#1A1200',
      backgroundColor1: '#2D1F00',
      backgroundColor2: '#1A1200',
      textColor1: '#FFFFFF',
      textColor2: '#FFE5AA',
      borderColor: '#FFB800',
      pointerColor: '#FFB800',
      radiusLineColor: '#2D1F00'
    }
  },
  {
    id: 'dragon-fortune',
    name: 'Dragon Fortune',
    category: 'bet',
    colors: {
      buttonGradient1: '#0D1F00',
      buttonGradient2: '#153300',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FF6600',
      buttonGlowColor: '#FF6600',
      headerBg: 'rgba(13, 31, 0, 0.9)',
      headerIconColor: '#FF6600',
      backgroundGradient1: '#060F00',
      backgroundGradient2: '#0D1F00',
      backgroundColor1: '#153300',
      backgroundColor2: '#0D1F00',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FF6600',
      pointerColor: '#FF6600',
      radiusLineColor: '#153300'
    }
  },
  {
    id: 'phoenix-rise',
    name: 'Phoenix Rising',
    category: 'bet',
    colors: {
      buttonGradient1: '#2D0A00',
      buttonGradient2: '#451500',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF5500',
      buttonGlowColor: '#FF5500',
      headerBg: 'rgba(45, 10, 0, 0.9)',
      headerIconColor: '#FF5500',
      backgroundGradient1: '#150500',
      backgroundGradient2: '#2D0A00',
      backgroundColor1: '#451500',
      backgroundColor2: '#2D0A00',
      textColor1: '#FFFFFF',
      textColor2: '#FFCC99',
      borderColor: '#FF5500',
      pointerColor: '#FF5500',
      radiusLineColor: '#451500'
    }
  },
  {
    id: 'thunder-bet',
    name: 'Thunder Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A0A1F',
      buttonGradient2: '#10102D',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFFF00',
      buttonGlowColor: '#FFFF00',
      headerBg: 'rgba(10, 10, 31, 0.9)',
      headerIconColor: '#FFFF00',
      backgroundGradient1: '#05050F',
      backgroundGradient2: '#0A0A1F',
      backgroundColor1: '#10102D',
      backgroundColor2: '#0A0A1F',
      textColor1: '#FFFFFF',
      textColor2: '#FFFFAA',
      borderColor: '#FFFF00',
      pointerColor: '#FFFF00',
      radiusLineColor: '#10102D'
    }
  },
  {
    id: 'golden-eagle',
    name: 'Golden Eagle',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A1000',
      buttonGradient2: '#2D1C00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#DAA520',
      buttonGlowColor: '#DAA520',
      headerBg: 'rgba(26, 16, 0, 0.9)',
      headerIconColor: '#DAA520',
      backgroundGradient1: '#0D0800',
      backgroundGradient2: '#1A1000',
      backgroundColor1: '#2D1C00',
      backgroundColor2: '#1A1000',
      textColor1: '#FFFFFF',
      textColor2: '#F5D37A',
      borderColor: '#DAA520',
      pointerColor: '#DAA520',
      radiusLineColor: '#2D1C00'
    }
  },
  {
    id: 'cash-blaze',
    name: 'Cash Blaze',
    category: 'bet',
    colors: {
      buttonGradient1: '#001A00',
      buttonGradient2: '#002D00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#00FF66',
      buttonGlowColor: '#00FF66',
      headerBg: 'rgba(0, 26, 0, 0.9)',
      headerIconColor: '#00FF66',
      backgroundGradient1: '#000D00',
      backgroundGradient2: '#001A00',
      backgroundColor1: '#002D00',
      backgroundColor2: '#001A00',
      textColor1: '#FFFFFF',
      textColor2: '#AAFFCC',
      borderColor: '#00FF66',
      pointerColor: '#00FF66',
      radiusLineColor: '#002D00'
    }
  },
  {
    id: 'night-fever',
    name: 'Night Fever',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A0025',
      buttonGradient2: '#2D003D',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF55BB',
      buttonGlowColor: '#FF55BB',
      headerBg: 'rgba(26, 0, 37, 0.9)',
      headerIconColor: '#FF55BB',
      backgroundGradient1: '#0D0012',
      backgroundGradient2: '#1A0025',
      backgroundColor1: '#2D003D',
      backgroundColor2: '#1A0025',
      textColor1: '#FFFFFF',
      textColor2: '#FFAAE0',
      borderColor: '#FF55BB',
      pointerColor: '#FF55BB',
      radiusLineColor: '#2D003D'
    }
  },
  {
    id: 'elite-bet',
    name: 'Elite Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#101018',
      buttonGradient2: '#181820',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#CCCCDD',
      buttonGlowColor: '#CCCCDD',
      headerBg: 'rgba(16, 16, 24, 0.9)',
      headerIconColor: '#CCCCDD',
      backgroundGradient1: '#060608',
      backgroundGradient2: '#101018',
      backgroundColor1: '#181820',
      backgroundColor2: '#101018',
      textColor1: '#FFFFFF',
      textColor2: '#CCCCDD',
      borderColor: '#CCCCDD',
      pointerColor: '#CCCCDD',
      radiusLineColor: '#181820'
    }
  },
  {
    id: 'prestige-club',
    name: 'Prestige Club',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A0A0A',
      buttonGradient2: '#141414',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#F0F0F0',
      buttonGlowColor: '#F0F0F0',
      headerBg: 'rgba(10, 10, 10, 0.9)',
      headerIconColor: '#F0F0F0',
      backgroundGradient1: '#000000',
      backgroundGradient2: '#0A0A0A',
      backgroundColor1: '#141414',
      backgroundColor2: '#0A0A0A',
      textColor1: '#FFFFFF',
      textColor2: '#CCCCCC',
      borderColor: '#F0F0F0',
      pointerColor: '#F0F0F0',
      radiusLineColor: '#141414'
    }
  },
  {
    id: 'fortune-king',
    name: 'Fortune King',
    category: 'bet',
    colors: {
      buttonGradient1: '#001033',
      buttonGradient2: '#001A50',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(0, 16, 51, 0.9)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#000819',
      backgroundGradient2: '#001033',
      backgroundColor1: '#001A50',
      backgroundColor2: '#001033',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#001A50'
    }
  },
  {
    id: 'casino-royale',
    name: 'Casino Royale',
    category: 'bet',
    colors: {
      buttonGradient1: '#14000A',
      buttonGradient2: '#200010',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#CC0022',
      buttonGlowColor: '#CC0022',
      headerBg: 'rgba(20, 0, 10, 0.9)',
      headerIconColor: '#CC0022',
      backgroundGradient1: '#0A0005',
      backgroundGradient2: '#14000A',
      backgroundColor1: '#200010',
      backgroundColor2: '#14000A',
      textColor1: '#FFFFFF',
      textColor2: '#FFAAAA',
      borderColor: '#CC0022',
      pointerColor: '#CC0022',
      radiusLineColor: '#200010'
    }
  },
  {
    id: 'velvet-club',
    name: 'Velvet Club',
    category: 'bet',
    colors: {
      buttonGradient1: '#1F0030',
      buttonGradient2: '#2D0045',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#9B6B9B',
      buttonGlowColor: '#9B6B9B',
      headerBg: 'rgba(31, 0, 48, 0.9)',
      headerIconColor: '#9B6B9B',
      backgroundGradient1: '#100018',
      backgroundGradient2: '#1F0030',
      backgroundColor1: '#2D0045',
      backgroundColor2: '#1F0030',
      textColor1: '#FFFFFF',
      textColor2: '#D4AAD4',
      borderColor: '#9B6B9B',
      pointerColor: '#9B6B9B',
      radiusLineColor: '#2D0045'
    }
  },
  {
    id: 'ace-of-spades',
    name: 'Ace of Spades',
    category: 'bet',
    colors: {
      buttonGradient1: '#050510',
      buttonGradient2: '#0F0F20',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#8888CC',
      buttonGlowColor: '#8888CC',
      headerBg: 'rgba(5, 5, 16, 0.9)',
      headerIconColor: '#8888CC',
      backgroundGradient1: '#020208',
      backgroundGradient2: '#050510',
      backgroundColor1: '#0F0F20',
      backgroundColor2: '#050510',
      textColor1: '#FFFFFF',
      textColor2: '#BBBBEE',
      borderColor: '#8888CC',
      pointerColor: '#8888CC',
      radiusLineColor: '#0F0F20'
    }
  },
  {
    id: 'sultan-bet',
    name: 'Sultan Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#1F0A30',
      buttonGradient2: '#33154D',
      buttonTextColor: '#FFD700',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(31, 10, 48, 0.9)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#0F0518',
      backgroundGradient2: '#1F0A30',
      backgroundColor1: '#33154D',
      backgroundColor2: '#1F0A30',
      textColor1: '#FFD700',
      textColor2: '#FFFFFF',
      borderColor: '#FFD700',
      pointerColor: '#FFD700',
      radiusLineColor: '#33154D'
    }
  },
  {
    id: 'neon-vegas',
    name: 'Neon Vegas',
    category: 'bet',
    colors: {
      buttonGradient1: '#14001E',
      buttonGradient2: '#20002E',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF44AA',
      buttonGlowColor: '#FF44AA',
      headerBg: 'rgba(20, 0, 30, 0.9)',
      headerIconColor: '#FF44AA',
      backgroundGradient1: '#0A000F',
      backgroundGradient2: '#14001E',
      backgroundColor1: '#20002E',
      backgroundColor2: '#14001E',
      textColor1: '#FFFFFF',
      textColor2: '#FF88CC',
      borderColor: '#FF44AA',
      pointerColor: '#FF44AA',
      radiusLineColor: '#20002E'
    }
  },
  {
    id: 'crimson-casino',
    name: 'Crimson Casino',
    category: 'bet',
    colors: {
      buttonGradient1: '#2A0005',
      buttonGradient2: '#3D0008',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#DC143C',
      buttonGlowColor: '#DC143C',
      headerBg: 'rgba(42, 0, 5, 0.9)',
      headerIconColor: '#DC143C',
      backgroundGradient1: '#140002',
      backgroundGradient2: '#2A0005',
      backgroundColor1: '#3D0008',
      backgroundColor2: '#2A0005',
      textColor1: '#FFFFFF',
      textColor2: '#FFAACC',
      borderColor: '#DC143C',
      pointerColor: '#DC143C',
      radiusLineColor: '#3D0008'
    }
  },
  {
    id: 'sapphire-bet',
    name: 'Sapphire Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#001A3D',
      buttonGradient2: '#002655',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#0080FF',
      buttonGlowColor: '#0080FF',
      headerBg: 'rgba(0, 26, 61, 0.9)',
      headerIconColor: '#0080FF',
      backgroundGradient1: '#000D1F',
      backgroundGradient2: '#001A3D',
      backgroundColor1: '#002655',
      backgroundColor2: '#001A3D',
      textColor1: '#FFFFFF',
      textColor2: '#AAD4FF',
      borderColor: '#0080FF',
      pointerColor: '#0080FF',
      radiusLineColor: '#002655'
    }
  },
  {
    id: 'tiger-bet',
    name: 'Tiger Bet',
    category: 'bet',
    colors: {
      buttonGradient1: '#1A0A00',
      buttonGradient2: '#2D1800',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FF8800',
      buttonGlowColor: '#FF8800',
      headerBg: 'rgba(26, 10, 0, 0.9)',
      headerIconColor: '#FF8800',
      backgroundGradient1: '#0D0500',
      backgroundGradient2: '#1A0A00',
      backgroundColor1: '#2D1800',
      backgroundColor2: '#1A0A00',
      textColor1: '#FFFFFF',
      textColor2: '#FFCC88',
      borderColor: '#FF8800',
      pointerColor: '#FF8800',
      radiusLineColor: '#2D1800'
    }
  },
  {
    id: 'vip-diamond',
    name: 'VIP Diamond',
    category: 'bet',
    colors: {
      buttonGradient1: '#0A0F1A',
      buttonGradient2: '#141E2D',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#A8D8EA',
      buttonGlowColor: '#A8D8EA',
      headerBg: 'rgba(10, 15, 26, 0.9)',
      headerIconColor: '#A8D8EA',
      backgroundGradient1: '#050810',
      backgroundGradient2: '#0A0F1A',
      backgroundColor1: '#141E2D',
      backgroundColor2: '#0A0F1A',
      textColor1: '#FFFFFF',
      textColor2: '#D0EEFF',
      borderColor: '#A8D8EA',
      pointerColor: '#A8D8EA',
      radiusLineColor: '#141E2D'
    }
  },
  {
    id: 'casino-gold',
    name: '🎰 Casino Gold',
    category: 'bet',
    colors: {
      buttonGradient1: '#B07500',
      buttonGradient2: '#E89C00',
      buttonTextColor: '#FFFFFF',
      buttonBorderColor: '#FFD700',
      buttonGlowColor: '#FFD700',
      headerBg: 'rgba(8, 15, 42, 0.94)',
      headerIconColor: '#FFD700',
      backgroundGradient1: '#07102A',
      backgroundGradient2: '#101E4A',
      backgroundColor1: '#0B1832',
      backgroundColor2: '#142040',
      textColor1: '#FFD700',
      textColor2: '#FFF0B0',
      borderColor: '#0B1832',
      pointerColor: '#FFD700',
      radiusLineColor: '#6B4F0A',
      wheelGlowColor: '#FFD700',
      wheelGlowOpacity: 0.35
    }
  }
];

// Tema ismine göre otomatik kategori ataması (Otobonus 14 kategori sistemi)
const categorizeTheme = (theme) => {
  const text = `${(theme.name || '').toLowerCase()} ${(theme.id || '').toLowerCase()}`;
  if (/cyber|punk|edge|hacker|matrix|glitch/.test(text)) return 'cyberpunk';
  if (/aurora|kutup|polar/.test(text)) return 'aurora';
  if (/pastel|yumuşak|soft/.test(text)) return 'pastel';
  if (/retro|80s|70s|60s|vintage|vhs|disco|polaroid|kaset|tüp|tube|synthwave|outrun|vapor|arcade|pinball/.test(text)) return 'retro';
  if (/gaming|xbox|playstation|nintendo|discord|twitch|steam|valorant|league|cs orange|esports/.test(text)) return 'gaming';
  if (/casino|kumarhane|vegas|poker|roulette|slot|jackpot|blackjack|baccarat|monte|sultan|spades|chip|fortune|prestige|royal|ace|crown|kraliyet|sapphire bet|tiger bet|crimson|sirius/.test(text)) return 'casino';
  if (/premium|altın|gold|elmas|diamond|platin|platinum|safir|ruby|yakut|emerald|zümrüt|amethyst|ametist|topaz|pearl|inci|bronz|opal|titan|champagne|şampanya|crystal|kristal|vip/.test(text)) return 'premium';
  if (/neon|electric|elektrik|asit/.test(text)) return 'neon';
  if (/ocean|okyanus|orman|forest|deniz|dağ|mountain|tropical|tropikal|cherry|kiraz|sahara|buzul|sage|adaçayı|jade|yeşim|lavanta|lavender|mercan|cypress|selvi|wild west|cherry blossom/.test(text)) return 'nature';
  if (/space|uzay|nebula|bulutsu|starfield|yıldız|milky|samanyolu|galaxy|galaksi|cosmos|kozmik|supernova|süpernova|black hole|kara delik|moon|ay|güneş|kuasar/.test(text)) return 'space';
  if (/japan|sakura|lotus|nilüfer|korean|kore|thai|tayland|geisha|geyşa|zen|vietnam|asya|east|doğu/.test(text)) return 'east';
  if (/minimal|monokrom|monochrome|sade|temiz/.test(text)) return 'minimal';
  if (/dark|koyu|gece|night|raven|kuzgun|onyx|oniks|charcoal|antrasit|coal|kömür|midnight|abyss|uçurum|obsidian|obsidyen|storm|fırtına|deep|derin|alacakaranlık/.test(text)) return 'dark';
  return 'general';
};

const updatedThemes = themes.map(theme => ({
  ...theme,
  category: categorizeTheme(theme)
}));

const updatedBetThemes = betThemes.map(theme => ({
  ...theme,
  category: theme.category || categorizeTheme(theme) || 'bet'
}));

// ════════════════════════════════════════
// Color utilities — Otobonus paleti çeviri için
// ════════════════════════════════════════
const hexToRgb = (hex) => {
  const h = (hex || '#000000').replace('#', '');
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  return {
    r: parseInt(full.slice(0, 2), 16) || 0,
    g: parseInt(full.slice(2, 4), 16) || 0,
    b: parseInt(full.slice(4, 6), 16) || 0,
  };
};

const rgbToHex = (r, g, b) => '#' + [r, g, b]
  .map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0'))
  .join('');

const lighten = (hex, pct) => {
  const { r, g, b } = hexToRgb(hex);
  const f = pct / 100;
  return rgbToHex(r + (255 - r) * f, g + (255 - g) * f, b + (255 - b) * f);
};

const darken = (hex, pct) => {
  const { r, g, b } = hexToRgb(hex);
  const f = 1 - pct / 100;
  return rgbToHex(r * f, g * f, b * f);
};

const alpha = (hex, opacity) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// Otobonus formatı (3 renk) → bizim format (15+ property)
const convertOtobonusTheme = ({ id, name, cat, bg, primary, secondary }) => ({
  id,
  name,
  category: cat,
  colors: {
    backgroundGradient1: bg,
    backgroundGradient2: lighten(bg, 8),
    backgroundColor1: lighten(bg, 18),
    backgroundColor2: bg,
    buttonGradient1: darken(primary, 50),
    buttonGradient2: darken(primary, 25),
    buttonTextColor: '#FFFFFF',
    buttonBorderColor: primary,
    buttonGlowColor: primary,
    headerBg: alpha(bg, 0.7),
    headerBorderColor: alpha(primary, 0.20),
    headerIconColor: primary,
    headerTextColor: '#FFFFFF',
    headerButtonBg: alpha(bg, 0.8),
    headerItemBg: alpha(bg, 0.5),
    headerItemText: '#FFFFFF',
    headerItemBorder: alpha(primary, 0.20),
    headerItemHoverBg: alpha(bg, 0.7),
    headerItemHoverBorder: alpha(primary, 0.40),
    headerEmojiColor: primary,
    textColor1: '#FFFFFF',
    textColor2: lighten(primary, 30),
    borderColor: primary,
    pointerColor: primary,
    wheelGlowColor: primary,
    wheelGlowOpacity: 0.30,
    radiusLineColor: secondary,
    buttonDisabled1: darken(bg, 10),
    buttonDisabled2: bg,
    buttonDisabledText: 'rgba(255, 255, 255, 0.40)',
    buttonDisabledBorder: alpha(primary, 0.20),
    modalBg: bg,
    modalBorderColor: primary,
    modalHeaderColor: '#FFFFFF',
    modalTextColor: lighten(primary, 30),
    modalButtonGradient1: darken(primary, 50),
    modalButtonGradient2: primary,
    modalButtonText: '#FFFFFF',
  },
});

// ════════════════════════════════════════
// Otobonus'tan eklenen 69 yeni tema
// (Aurora, Pastel, Retro, Gaming, Cyberpunk kategorileri)
// ════════════════════════════════════════
const OTOBONUS_NEW_THEMES = [
  { id: "midnight-sky", name: "Gece Gökyüzü", cat: 'dark', bg: '#080d19', primary: '#0ea5e9', secondary: '#0284c7' },
  { id: "obsidian", name: "Obsidyen", cat: 'dark', bg: '#09090b', primary: '#71717a', secondary: '#52525b' },
  { id: "deep-navy", name: "Derin Lacivert", cat: 'dark', bg: '#030712', primary: '#3b82f6', secondary: '#2563eb' },
  { id: "charcoal", name: "Antrasit", cat: 'dark', bg: '#111827', primary: '#6366f1', secondary: '#4f46e5' },
  { id: "dark-forest", name: "Karanlık Orman", cat: 'dark', bg: '#052e16', primary: '#22c55e', secondary: '#16a34a' },
  { id: "dark-wine", name: "Koyu Şarap", cat: 'dark', bg: '#1c0a0a', primary: '#dc2626', secondary: '#b91c1c' },
  { id: "midnight-purple", name: "Gece Moru", cat: 'dark', bg: '#0d0414', primary: '#a855f7', secondary: '#9333ea' },
  { id: "onyx", name: "Oniks", cat: 'dark', bg: '#0a0a0a', primary: '#f59e0b', secondary: '#d97706' },
  { id: "dark-teal", name: "Koyu Teal", cat: 'dark', bg: '#042323', primary: '#14b8a6', secondary: '#0d9488' },
  { id: "storm-night", name: "Fırtına Gecesi", cat: 'dark', bg: '#0f172a', primary: '#64748b', secondary: '#475569' },
  { id: "velvet-dark", name: "Kadife Karanlık", cat: 'dark', bg: '#1a0533', primary: '#c084fc', secondary: '#a855f7' },
  { id: "raven", name: "Kuzgun", cat: 'dark', bg: '#050508', primary: '#818cf8', secondary: '#6366f1' },
  { id: "abyss", name: "Uçurum", cat: 'dark', bg: '#020617', primary: '#38bdf8', secondary: '#0ea5e9' },
  { id: "neon-blue", name: "Neon Mavi", cat: 'neon', bg: '#030b14', primary: '#00d4ff', secondary: '#0080ff' },
  { id: "neon-green", name: "Neon Yeşil", cat: 'neon', bg: '#030f09', primary: '#00ff88', secondary: '#00cc66' },
  { id: "neon-purple", name: "Neon Mor", cat: 'neon', bg: '#0d0014', primary: '#bf00ff', secondary: '#8800cc' },
  { id: "neon-red", name: "Neon Kırmızı", cat: 'neon', bg: '#140303', primary: '#ff0040', secondary: '#cc0030' },
  { id: "neon-orange", name: "Neon Turuncu", cat: 'neon', bg: '#140a00', primary: '#ff6600', secondary: '#ff4400' },
  { id: "neon-pink", name: "Neon Pembe", cat: 'neon', bg: '#14000f', primary: '#ff00aa', secondary: '#cc0088' },
  { id: "neon-yellow", name: "Neon Sarı", cat: 'neon', bg: '#0f0f00', primary: '#ffee00', secondary: '#ccbb00' },
  { id: "neon-aqua", name: "Neon Aqua", cat: 'neon', bg: '#00100f', primary: '#00ffdd', secondary: '#00ccaa' },
  { id: "neon-magenta", name: "Neon Magenta", cat: 'neon', bg: '#140010', primary: '#ff00ff', secondary: '#cc00cc' },
  { id: "neon-lime", name: "Neon Limon", cat: 'neon', bg: '#0a0f00', primary: '#aaff00', secondary: '#88cc00' },
  { id: "cyber-blue", name: "Siber Mavi", cat: 'neon', bg: '#020d1a', primary: '#00b4d8', secondary: '#0096c7' },
  { id: "electric-violet", name: "Elektrik Viyole", cat: 'neon', bg: '#0c0012', primary: '#7c3aed', secondary: '#6d28d9' },
  { id: "matrix", name: "Matrix", cat: 'neon', bg: '#000d00', primary: '#00ff41', secondary: '#00cc33' },
  { id: "cyber-gold", name: "Siber Altın", cat: 'neon', bg: '#0f0a00', primary: '#ffd700', secondary: '#ffaa00' },
  { id: "platinum", name: "Platin", cat: 'premium', bg: '#0f1117', primary: '#e2e8f0', secondary: '#cbd5e1' },
  { id: "rose-gold", name: "Gül Altını", cat: 'premium', bg: '#1a0d10', primary: '#f43f5e', secondary: '#e11d48' },
  { id: "diamond", name: "Elmas", cat: 'premium', bg: '#060d1a', primary: '#bae6fd', secondary: '#7dd3fc' },
  { id: "emerald", name: "Zümrüt", cat: 'premium', bg: '#021a0d', primary: '#10b981', secondary: '#059669' },
  { id: "sapphire", name: "Safir", cat: 'premium', bg: '#02081a', primary: '#2563eb', secondary: '#1d4ed8' },
  { id: "ruby", name: "Yakut", cat: 'premium', bg: '#1a0204', primary: '#ef4444', secondary: '#dc2626' },
  { id: "amethyst", name: "Ametist", cat: 'premium', bg: '#10021a', primary: '#8b5cf6', secondary: '#7c3aed' },
  { id: "topaz", name: "Topaz", cat: 'premium', bg: '#0d1200', primary: '#84cc16', secondary: '#65a30d' },
  { id: "onyx-gold", name: "Oniks Altın", cat: 'premium', bg: '#0a0800', primary: '#ca8a04', secondary: '#a16207' },
  { id: "silver-elite", name: "Gümüş Elite", cat: 'premium', bg: '#0c0f14', primary: '#94a3b8', secondary: '#64748b' },
  { id: "pearl", name: "İnci", cat: 'premium', bg: '#0d0f12', primary: '#f1f5f9', secondary: '#e2e8f0' },
  { id: "bronze-age", name: "Bronz Çağ", cat: 'premium', bg: '#0f0700', primary: '#d97706', secondary: '#b45309' },
  { id: "vip-purple", name: "VIP Mor", cat: 'premium', bg: '#0a0014', primary: '#9333ea', secondary: '#7e22ce' },
  { id: "vegas-nights", name: "Vegas Geceleri", cat: 'casino', bg: '#0d0000', primary: '#ef4444', secondary: '#dc2626' },
  { id: "blackjack", name: "Blackjack", cat: 'casino', bg: '#001a00', primary: '#22c55e', secondary: '#16a34a' },
  { id: "golden-casino", name: "Altın Kumarhane", cat: 'casino', bg: '#0d0800', primary: '#eab308', secondary: '#ca8a04' },
  { id: "casino-royale", name: "Casino Royale", cat: 'casino', bg: '#000d1a', primary: '#3b82f6', secondary: '#2563eb' },
  { id: "poker-table", name: "Poker Masası", cat: 'casino', bg: '#00150a', primary: '#34d399', secondary: '#10b981' },
  { id: "lucky-red", name: "Şanslı Kırmızı", cat: 'casino', bg: '#1a0000', primary: '#ff1a1a', secondary: '#cc0000' },
  { id: "high-roller", name: "High Roller", cat: 'casino', bg: '#0a0700', primary: '#fbbf24', secondary: '#f59e0b' },
  { id: "jackpot", name: "Jackpot", cat: 'casino', bg: '#0d0500', primary: '#fb923c', secondary: '#f97316' },
  { id: "royal-flush", name: "Royal Flush", cat: 'casino', bg: '#08001a', primary: '#a78bfa', secondary: '#8b5cf6' },
  { id: "ocean-breeze", name: "Okyanus Esintisi", cat: 'nature', bg: '#001020', primary: '#0ea5e9', secondary: '#0284c7' },
  { id: "forest-mist", name: "Orman Sisi", cat: 'nature', bg: '#021a08', primary: '#16a34a', secondary: '#15803d' },
  { id: "arctic-aurora", name: "Kutup Işıkları", cat: 'nature', bg: '#020d1a', primary: '#06b6d4', secondary: '#0891b2' },
  { id: "desert-oasis", name: "Çöl Vahası", cat: 'nature', bg: '#150d00', primary: '#f59e0b', secondary: '#d97706' },
  { id: "volcanic", name: "Volkanik", cat: 'nature', bg: '#1a0300', primary: '#f97316', secondary: '#ea580c' },
  { id: "cherry-blossom", name: "Kiraz Çiçeği", cat: 'nature', bg: '#1a0010', primary: '#fb7185', secondary: '#f43f5e' },
  { id: "deep-ocean", name: "Derin Okyanus", cat: 'nature', bg: '#001020', primary: '#0284c7', secondary: '#0369a1' },
  { id: "tropical", name: "Tropikal", cat: 'nature', bg: '#001a0a', primary: '#34d399', secondary: '#10b981' },
  { id: "lavender-field", name: "Lavanta Tarlası", cat: 'nature', bg: '#0d0a1a', primary: '#a78bfa', secondary: '#8b5cf6' },
  { id: "jade-garden", name: "Yeşim Bahçesi", cat: 'nature', bg: '#011a08', primary: '#4ade80', secondary: '#22c55e' },
  { id: "nebula", name: "Bulutsu", cat: 'space', bg: '#08021a', primary: '#e879f9', secondary: '#d946ef' },
  { id: "starfield", name: "Yıldız Alanı", cat: 'space', bg: '#020209', primary: '#f8fafc', secondary: '#cbd5e1' },
  { id: "milky-way", name: "Samanyolu", cat: 'space', bg: '#04020d', primary: '#93c5fd', secondary: '#60a5fa' },
  { id: "black-hole", name: "Kara Delik", cat: 'space', bg: '#000000', primary: '#6366f1', secondary: '#4f46e5' },
  { id: "supernova", name: "Süpernova", cat: 'space', bg: '#0f0205', primary: '#fb923c', secondary: '#f97316' },
  { id: "solar-wind", name: "Güneş Rüzgarı", cat: 'space', bg: '#150a00', primary: '#fde68a', secondary: '#fcd34d' },
  { id: "galaxy-purple", name: "Galaksi Moru", cat: 'space', bg: '#070014', primary: '#d8b4fe', secondary: '#c084fc' },
  { id: "retro-wave", name: "Retro Dalga", cat: 'space', bg: '#0d0020', primary: '#f0abfc', secondary: '#e879f9' },
  { id: "minimal-blue", name: "Minimal Mavi", cat: 'minimal', bg: '#0a1020', primary: '#60a5fa', secondary: '#3b82f6' },
  { id: "minimal-green", name: "Minimal Yeşil", cat: 'minimal', bg: '#0a1a0d', primary: '#86efac', secondary: '#4ade80' },
  { id: "minimal-purple", name: "Minimal Mor", cat: 'minimal', bg: '#100a20', primary: '#c4b5fd', secondary: '#a78bfa' },
  { id: "monochrome", name: "Monokrom", cat: 'minimal', bg: '#0a0a0a', primary: '#737373', secondary: '#525252' },
  { id: "ice-cold", name: "Buz Gibi", cat: 'minimal', bg: '#060d1a', primary: '#e0f2fe', secondary: '#bae6fd' },
  { id: "warm-amber", name: "Sıcak Amber", cat: 'minimal', bg: '#140e00', primary: '#fde68a', secondary: '#fcd34d' },
  { id: "soft-rose", name: "Yumuşak Gül", cat: 'minimal', bg: '#1a0810', primary: '#fda4af', secondary: '#fb7185' },
  { id: "sage", name: "Adaçayı", cat: 'minimal', bg: '#0a140d', primary: '#86efac', secondary: '#4ade80' },
  { id: "indigo-night", name: "İndigo Gecesi", cat: 'minimal', bg: '#040714', primary: '#a5b4fc', secondary: '#818cf8' },
  { id: "japan-sakura", name: "Japon Sakurası", cat: 'east', bg: '#1a0010', primary: '#f9a8d4', secondary: '#f472b6' },
  { id: "lotus-flower", name: "Nilüfer Çiçeği", cat: 'east', bg: '#1a0015', primary: '#f0abfc', secondary: '#e879f9' },
  { id: "korean-sky", name: "Kore Gökyüzü", cat: 'east', bg: '#00091a', primary: '#93c5fd', secondary: '#60a5fa' },
  { id: "thai-gold", name: "Tayland Altını", cat: 'east', bg: '#0f0800', primary: '#fcd34d', secondary: '#fbbf24' },
  { id: "geisha", name: "Geyşa", cat: 'east', bg: '#140010', primary: '#f472b6', secondary: '#ec4899' },
  { id: "zen-garden", name: "Zen Bahçesi", cat: 'east', bg: '#080a0a', primary: '#94a3b8', secondary: '#64748b' },
  { id: "vietnam-star", name: "Vietnam Yıldızı", cat: 'east', bg: '#1a0000', primary: '#facc15', secondary: '#ef4444' },
  { id: "coal-black", name: "Kömür Siyahı", cat: 'dark', bg: '#050505', primary: '#525252', secondary: '#404040' },
  { id: "deep-indigo", name: "Derin İndigo", cat: 'dark', bg: '#050514', primary: '#818cf8', secondary: '#6366f1' },
  { id: "neon-cyan", name: "Neon Cyan", cat: 'neon', bg: '#001014', primary: '#06ffff', secondary: '#00cccc' },
  { id: "neon-coral", name: "Neon Mercan", cat: 'neon', bg: '#140500', primary: '#ff5e3a', secondary: '#cc4828' },
  { id: "neon-mint", name: "Neon Nane", cat: 'neon', bg: '#001408', primary: '#00ffaa', secondary: '#00cc88' },
  { id: "royal-purple-prem", name: "Kraliyet Moru", cat: 'premium', bg: '#0d0014', primary: '#6d28d9', secondary: '#5b21b6' },
  { id: "champagne-gold", name: "Şampanya Altını", cat: 'premium', bg: '#14110a', primary: '#fbbf24', secondary: '#f59e0b' },
  { id: "black-pearl", name: "Siyah İnci", cat: 'premium', bg: '#050608', primary: '#cbd5e1', secondary: '#94a3b8' },
  { id: "royal-crown", name: "Kraliyet Tacı", cat: 'casino', bg: '#0a0014', primary: '#facc15', secondary: '#b91c1c' },
  { id: "slot-machine", name: "Slot Makinesi", cat: 'casino', bg: '#1a0a00', primary: '#fbbf24', secondary: '#dc2626' },
  { id: "mountain-mist", name: "Dağ Sisi", cat: 'nature', bg: '#0a141a', primary: '#38bdf8', secondary: '#94a3b8' },
  { id: "quasar", name: "Kuasar", cat: 'space', bg: '#06020f', primary: '#f472b6', secondary: '#c026d3' },
  { id: "minimal-coral", name: "Minimal Mercan", cat: 'minimal', bg: '#14080a', primary: '#fda4af', secondary: '#fb7185' },
  { id: "minimal-yellow", name: "Minimal Sarı", cat: 'minimal', bg: '#14130a', primary: '#fde047', secondary: '#facc15' },
  { id: "minimal-black", name: "Minimal Siyah", cat: 'minimal', bg: '#050505', primary: '#d4d4d8', secondary: '#a1a1aa' },
  { id: "cp-night-city", name: "Night City", cat: 'cyberpunk', bg: '#050514', primary: '#facc15', secondary: '#ef4444' },
  { id: "cp-edgerunners", name: "Edgerunners", cat: 'cyberpunk', bg: '#0a0a14', primary: '#fbbf24', secondary: '#f0abfc' },
  { id: "cp-blade-runner", name: "Blade Runner 2049", cat: 'cyberpunk', bg: '#1a0a05', primary: '#f97316', secondary: '#06b6d4' },
  { id: "cp-tokyo-glitch", name: "Tokyo Glitch", cat: 'cyberpunk', bg: '#0a0014', primary: '#ff00aa', secondary: '#00ffff' },
  { id: "cp-neo-tokyo", name: "Neo-Tokyo", cat: 'cyberpunk', bg: '#14000a', primary: '#ff0066', secondary: '#c026d3' },
  { id: "cp-synthwave", name: "Synthwave Highway", cat: 'cyberpunk', bg: '#0a0028', primary: '#ec4899', secondary: '#8b5cf6' },
  { id: "cp-outrun", name: "Outrun", cat: 'cyberpunk', bg: '#0d0024', primary: '#ff00ff', secondary: '#00ffff' },
  { id: "cp-vaporwave", name: "Vaporwave", cat: 'cyberpunk', bg: '#14001a', primary: '#f0abfc', secondary: '#67e8f9' },
  { id: "cp-acid-house", name: "Acid House", cat: 'cyberpunk', bg: '#00140a', primary: '#84cc16', secondary: '#d946ef' },
  { id: "cp-cyber-samurai", name: "Siber Samuray", cat: 'cyberpunk', bg: '#0a0a0a', primary: '#fbbf24', secondary: '#dc2626' },
  { id: "cp-hologram", name: "Hologram", cat: 'cyberpunk', bg: '#0a0014', primary: '#22d3ee', secondary: '#e879f9' },
  { id: "cp-punk-anarchy", name: "Punk Anarchy", cat: 'cyberpunk', bg: '#140000', primary: '#ef4444', secondary: '#f8fafc' },
  { id: "cp-glitch-wave", name: "Glitch Wave", cat: 'cyberpunk', bg: '#0d0014', primary: '#f472b6', secondary: '#06b6d4' },
  { id: "cp-hacker-term", name: "Hacker Terminal", cat: 'cyberpunk', bg: '#000800', primary: '#4ade80', secondary: '#166534' },
  { id: "cp-neon-district", name: "Neon Bölge", cat: 'cyberpunk', bg: '#14001a', primary: '#c084fc', secondary: '#fde047' },
  { id: "cp-future-nights", name: "Future Nights", cat: 'cyberpunk', bg: '#000a14', primary: '#38bdf8', secondary: '#fbbf24' },
  { id: "cp-wasteland", name: "Industrial Wasteland", cat: 'cyberpunk', bg: '#14100a', primary: '#f97316', secondary: '#525252' },
  { id: "cp-dystopia-red", name: "Dystopia Red", cat: 'cyberpunk', bg: '#1a0000', primary: '#dc2626', secondary: '#18181b' },
  { id: "cp-yakuza", name: "Yakuza Neon", cat: 'cyberpunk', bg: '#1a0000', primary: '#ef4444', secondary: '#eab308' },
  { id: "cp-datastream", name: "Datastream", cat: 'cyberpunk', bg: '#001008', primary: '#22c55e', secondary: '#a855f7' },
  { id: "cp-underground", name: "Underground Club", cat: 'cyberpunk', bg: '#1a0028', primary: '#d946ef', secondary: '#8b5cf6' },
  { id: "cp-chrome", name: "Chrome Future", cat: 'cyberpunk', bg: '#0a141a', primary: '#67e8f9', secondary: '#cbd5e1' },
  { id: "cp-sunset-hw", name: "Sunset Highway", cat: 'cyberpunk', bg: '#14000a', primary: '#fb923c', secondary: '#ec4899' },
  { id: "cp-solar-punk", name: "Solarpunk", cat: 'cyberpunk', bg: '#0a1400', primary: '#84cc16', secondary: '#fbbf24' },
  { id: "cp-steam-punk", name: "Steampunk", cat: 'cyberpunk', bg: '#14080a', primary: '#c2410c', secondary: '#14b8a6' },
  { id: "cp-bio-hazard", name: "Bio Hazard", cat: 'cyberpunk', bg: '#0a0a00', primary: '#facc15', secondary: '#c084fc' },
  { id: "cp-replicant", name: "Replicant", cat: 'cyberpunk', bg: '#0a080a', primary: '#fb923c', secondary: '#06b6d4' },
  { id: "pastel-pink", name: "Pastel Pembe", cat: 'pastel', bg: '#1a0e14', primary: '#fbcfe8', secondary: '#f9a8d4' },
  { id: "pastel-blue", name: "Pastel Mavi", cat: 'pastel', bg: '#0c1424', primary: '#bfdbfe', secondary: '#93c5fd' },
  { id: "pastel-lavender", name: "Pastel Lavanta", cat: 'pastel', bg: '#150c20', primary: '#ddd6fe', secondary: '#c4b5fd' },
  { id: "pastel-mint", name: "Pastel Nane", cat: 'pastel', bg: '#0c1f17', primary: '#a7f3d0', secondary: '#6ee7b7' },
  { id: "pastel-peach", name: "Pastel Şeftali", cat: 'pastel', bg: '#1f140c', primary: '#fed7aa', secondary: '#fdba74' },
  { id: "pastel-yellow", name: "Pastel Sarı", cat: 'pastel', bg: '#1f1c0c', primary: '#fef3c7', secondary: '#fde68a' },
  { id: "pastel-coral", name: "Pastel Mercan", cat: 'pastel', bg: '#1f0e0e', primary: '#fecaca', secondary: '#fca5a5' },
  { id: "pastel-lilac", name: "Pastel Leylak", cat: 'pastel', bg: '#140a1f', primary: '#e9d5ff', secondary: '#d8b4fe' },
  { id: "pastel-sky", name: "Pastel Gökyüzü", cat: 'pastel', bg: '#0a1420', primary: '#bae6fd', secondary: '#7dd3fc' },
  { id: "pastel-sage", name: "Pastel Adaçayı", cat: 'pastel', bg: '#0e140d', primary: '#d9f99d', secondary: '#bef264' },
  { id: "pastel-lemon", name: "Pastel Limon", cat: 'pastel', bg: '#14130a', primary: '#fef08a', secondary: '#fde047' },
  { id: "pastel-powder", name: "Pastel Pudra", cat: 'pastel', bg: '#0a141a', primary: '#cffafe', secondary: '#a5f3fc' },
  { id: "aurora-borealis", name: "Aurora Borealis", cat: 'aurora', bg: '#020817', primary: '#22d3ee', secondary: '#a855f7' },
  { id: "aurora-pink", name: "Aurora Pembe", cat: 'aurora', bg: '#0d0817', primary: '#f0abfc', secondary: '#a855f7' },
  { id: "aurora-green-sky", name: "Aurora Yeşil Gök", cat: 'aurora', bg: '#001020', primary: '#4ade80', secondary: '#3b82f6' },
  { id: "aurora-iceland", name: "Aurora İzlanda", cat: 'aurora', bg: '#02061a', primary: '#14b8a6', secondary: '#6366f1' },
  { id: "aurora-norway", name: "Aurora Norveç", cat: 'aurora', bg: '#050a1f', primary: '#34d399', secondary: '#8b5cf6' },
  { id: "aurora-alaska", name: "Aurora Alaska", cat: 'aurora', bg: '#050813', primary: '#06b6d4', secondary: '#a78bfa' },
  { id: "aurora-magnetic", name: "Aurora Manyetik", cat: 'aurora', bg: '#020a14', primary: '#e879f9', secondary: '#67e8f9' },
  { id: "aurora-polar", name: "Aurora Polar", cat: 'aurora', bg: '#00081a', primary: '#7dd3fc', secondary: '#c084fc' },
  { id: "aurora-spectrum", name: "Aurora Spektrum", cat: 'aurora', bg: '#060818', primary: '#6ee7b7', secondary: '#c084fc' },
  { id: "aurora-dreams", name: "Aurora Rüyaları", cat: 'aurora', bg: '#08081f', primary: '#5eead4', secondary: '#ddd6fe' },
  { id: "retro-80s-synth", name: "80s Synthwave", cat: 'retro', bg: '#0d0024', primary: '#ec4899', secondary: '#06b6d4' },
  { id: "retro-70s-disco", name: "70s Disco", cat: 'retro', bg: '#14001a', primary: '#fbbf24', secondary: '#f97316' },
  { id: "retro-60s-hippie", name: "60s Hippie", cat: 'retro', bg: '#1a0a00', primary: '#f97316', secondary: '#a855f7' },
  { id: "retro-vhs", name: "VHS Kaset", cat: 'retro', bg: '#0a0a14', primary: '#06b6d4', secondary: '#ec4899' },
  { id: "retro-pinball", name: "Pinball Arcade", cat: 'retro', bg: '#0a0000', primary: '#dc2626', secondary: '#facc15' },
  { id: "retro-tube", name: "Vintage Tüp", cat: 'retro', bg: '#140a00', primary: '#d97706', secondary: '#dc2626' },
  { id: "retro-diner", name: "Retro Diner", cat: 'retro', bg: '#001a14', primary: '#fb923c', secondary: '#ef4444' },
  { id: "retro-newspaper", name: "Eski Gazete", cat: 'retro', bg: '#140d05', primary: '#fef3c7', secondary: '#a8a29e' },
  { id: "retro-cassette", name: "Kaset", cat: 'retro', bg: '#002020', primary: '#f97316', secondary: '#a855f7' },
  { id: "retro-polaroid", name: "Polaroid", cat: 'retro', bg: '#1a1408', primary: '#fb923c', secondary: '#c084fc' },
  { id: "gaming-twitch", name: "Twitch Purple", cat: 'gaming', bg: '#0e0e14', primary: '#9146ff', secondary: '#6441a4' },
  { id: "gaming-xbox", name: "Xbox Green", cat: 'gaming', bg: '#0a0f0a', primary: '#16a34a', secondary: '#15803d' },
  { id: "gaming-playstation", name: "PlayStation Blue", cat: 'gaming', bg: '#0a0a14', primary: '#003791', secondary: '#006fcd' },
  { id: "gaming-nintendo", name: "Nintendo Red", cat: 'gaming', bg: '#1a0000', primary: '#e60012', secondary: '#c00010' },
  { id: "gaming-discord", name: "Discord Blurple", cat: 'gaming', bg: '#0e0e14', primary: '#5865f2', secondary: '#4752c4' },
  { id: "gaming-steam", name: "Steam", cat: 'gaming', bg: '#1b2838', primary: '#66c0f4', secondary: '#5e98c4' },
  { id: "gaming-valorant", name: "Valorant", cat: 'gaming', bg: '#0a0c14', primary: '#fa4454', secondary: '#18e4b7' },
  { id: "gaming-league", name: "League of Legends", cat: 'gaming', bg: '#0a0e1a', primary: '#c89b3c', secondary: '#cdfafa' },
  { id: "gaming-cs", name: "CS Orange", cat: 'gaming', bg: '#0c0e1a', primary: '#ff7700', secondary: '#1c4dff' },
  { id: "gaming-esports", name: "Esports Neon", cat: 'gaming', bg: '#0a0a0a', primary: '#00ff88', secondary: '#ff00bb' },
];

const otobonusConverted = OTOBONUS_NEW_THEMES.map(convertOtobonusTheme);

const allThemes = [...otobonusConverted];

const categories = [
  { id: 'all',       name: 'Tümü' },
  { id: 'cyberpunk', name: 'Cyberpunk' },
  { id: 'dark',      name: 'Koyu' },
  { id: 'neon',      name: 'Neon' },
  { id: 'premium',   name: 'Premium' },
  { id: 'casino',    name: 'Kumarhane' },
  { id: 'nature',    name: 'Doğa' },
  { id: 'space',     name: 'Uzay & Siber' },
  { id: 'aurora',    name: 'Aurora' },
  { id: 'pastel',    name: 'Pastel' },
  { id: 'retro',     name: 'Retro / 80s' },
  { id: 'gaming',    name: 'Gaming' },
  { id: 'minimal',   name: 'Minimal' },
  { id: 'east',      name: 'Uzak Doğu' },
  { id: 'bet',       name: 'Bet' },
  { id: 'general',   name: 'Diğer' },
];

const NEW_THEME_IDS = new Set([
  'buz-kristali', 'neon-pembe', 'yildiz-tozu', 'kiremit', 'indigo-cosmos',
  'asit-lime', 'gul-altini', 'kan-ayi', 'yesim-tapinagi', 'kobalt-mavisi',
  'elektrik-viyole', 'firtina-gece', 'seker-pembe', 'derin-uzay', 'neon-turuncu',
  'neon-aqua', 'gece-eflatun', 'bronz-cag', 'mor-alev', 'mercan-resifi',
  'altin-cag', 'pasifik-mavi', 'limon-neon', 'elmas', 'titan-gri',
  'sirius-yildizi', 'pembe-alev', 'selvi-yesili', 'sahara', 'buzul',
  'alacakaranlik', 'deniz-yosunu', 'kayan-yildiz', 'gece-meneksesi',
  'kor-kirmizi', 'opal',
  'black-jack', 'poker-table', 'roulette', 'slot-machine', 'baccarat',
  'high-roller', 'fortune-tiger', 'dice-master', 'crown-casino', 'wild-west',
  'monte-carlo', 'jackpot-city', 'dragon-fortune', 'phoenix-rise', 'thunder-bet',
  'golden-eagle', 'cash-blaze', 'night-fever', 'elite-bet', 'prestige-club',
  'fortune-king', 'casino-royale', 'velvet-club', 'ace-of-spades', 'sultan-bet',
  'neon-vegas', 'crimson-casino', 'sapphire-bet', 'tiger-bet', 'vip-diamond',
  'casino-gold'
]);

const ThemeSelector = ({ onApplyTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [activeThemeId, setActiveThemeId] = useState(null);

  // Dışarı tıklanınca kapatma için ref
  const panelRef = useRef(null);

  // Dışarı tıklanınca kapatma fonksiyonu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleThemeClick = (theme) => {
    setActiveThemeId(theme.id);
    onApplyTheme(theme.colors);
    setIsOpen(false);
  };

  const filteredThemes = allThemes.filter(theme => {
    const matchesSearch = theme.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || theme.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <>
      <button 
        className="theme-selector-button" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className="fas fa-palette"></i>
        Hook - Tema
      </button>

      {isOpen && (
        <div className="theme-selector-panel" ref={panelRef}>
          <div className="theme-selector-header">
            <h3>Tema Seçenekleri</h3>
            <button 
              className="close-button"
              onClick={() => setIsOpen(false)}
              aria-label="Kapat"
            >
              <CloseIcon />
            </button>
          </div>

          <div className="theme-filters">
            <div className="theme-search">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Tema ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="category-filters">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`category-filter ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
          
          <div className="theme-count">{filteredThemes.length} tema</div>

          <div className="themes-container">
            <div className="themes-grid">
              {filteredThemes.map(theme => (
                <div
                  key={theme.id}
                  className={`theme-item${activeThemeId === theme.id ? ' active' : ''}`}
                  onClick={() => handleThemeClick(theme)}
                  title={theme.name}
                >
                  {activeThemeId === theme.id && (
                    <div className="theme-active-mark" aria-hidden="true">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </div>
                  )}
                  {NEW_THEME_IDS.has(theme.id) && (
                    <span className="theme-new-badge">YENİ</span>
                  )}
                  <div
                    className="theme-preview"
                    style={{
                      background: `linear-gradient(165deg, ${theme.colors.backgroundGradient1}, ${theme.colors.backgroundGradient2})`
                    }}
                  >
                    <div className="preview-bar" style={{ background: theme.colors.buttonBorderColor }} />
                    <div className="preview-dot" style={{ background: theme.colors.borderColor }} />
                  </div>
                  <span className="theme-name">{theme.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ThemeSelector; 